/*! ScrollMagic v2.0.8 | (c) 2020 Jan Paepke (@janpaepke) | license & info: http://scrollmagic.io */
!function(e,t){"function"==typeof define&&define.amd?define(t):"object"==typeof exports?module.exports=t():e.ScrollMagic=t()}(this,function(){"use strict";function _(){}_.version="2.0.8","undefined"!=typeof window&&window.addEventListener("mousewheel",void 0);var P="data-scrollmagic-pin-spacer";_.Controller=function(e){function t(){var e,t,n;v&&u&&(e=R.type.Array(u)?u:f.slice(0),u=!1,t=d,0!=(n=(d=l.scrollPos())-t)&&(h=0<n?"FORWARD":i),h===i&&e.reverse(),e.forEach(function(e,t){e.update(!0)}))}function r(){n=R.rAF(t)}var n,o,i="REVERSE",s="PAUSED",a=z.defaults,l=this,c=R.extend({},a,e),f=[],u=!1,d=0,h=s,p=!0,g=0,v=!0,m=function(){0<c.refreshInterval&&(o=window.setTimeout(E,c.refreshInterval))},w=function(){return c.vertical?R.get.scrollTop(c.container):R.get.scrollLeft(c.container)},y=function(){return c.vertical?R.get.height(c.container):R.get.width(c.container)},S=this._setScrollPos=function(e){c.vertical?p?window.scrollTo(R.get.scrollLeft(),e):c.container.scrollTop=e:p?window.scrollTo(e,R.get.scrollTop()):c.container.scrollLeft=e},b=function(e){"resize"==e.type&&(g=y(),h=s),!0!==u&&(u=!0,r())},E=function(){if(!p&&g!=y()){var t;try{t=new Event("resize",{bubbles:!1,cancelable:!1})}catch(e){(t=document.createEvent("Event")).initEvent("resize",!1,!1)}c.container.dispatchEvent(t)}f.forEach(function(e,t){e.refresh()}),m()};this._options=c;function x(e){if(e.length<=1)return e;var t=e.slice(0);return t.sort(function(e,t){return e.scrollOffset()>t.scrollOffset()?1:-1}),t}return this.addScene=function(e){if(R.type.Array(e))e.forEach(function(e,t){l.addScene(e)});else if(e instanceof _.Scene)if(e.controller()!==l)e.addTo(l);else if(!~f.indexOf(e))for(var t in f.push(e),f=x(f),e.on("shift.controller_sort",function(){f=x(f)}),c.globalSceneOptions)e[t]&&e[t].call(e,c.globalSceneOptions[t]);return l},this.removeScene=function(e){var t;return R.type.Array(e)?e.forEach(function(e,t){l.removeScene(e)}):-1<(t=f.indexOf(e))&&(e.off("shift.controller_sort"),f.splice(t,1),e.remove()),l},this.updateScene=function(e,n){return R.type.Array(e)?e.forEach(function(e,t){l.updateScene(e,n)}):n?e.update(!0):!0!==u&&e instanceof _.Scene&&(~(u=u||[]).indexOf(e)||u.push(e),u=x(u),r()),l},this.update=function(e){return b({type:"resize"}),e&&t(),l},this.scrollTo=function(e,t){if(R.type.Number(e))S.call(c.container,e,t);else if(e instanceof _.Scene)e.controller()===l&&l.scrollTo(e.scrollOffset(),t);else if(R.type.Function(e))S=e;else{var n=R.get.elements(e)[0];if(n){for(;n.parentNode.hasAttribute(P);)n=n.parentNode;var r=c.vertical?"top":"left",o=R.get.offset(c.container),i=R.get.offset(n);p||(o[r]-=l.scrollPos()),l.scrollTo(i[r]-o[r],t)}}return l},this.scrollPos=function(e){return arguments.length?(R.type.Function(e)&&(w=e),l):w.call(l)},this.info=function(e){var t={size:g,vertical:c.vertical,scrollPos:d,scrollDirection:h,container:c.container,isDocument:p};return arguments.length?void 0!==t[e]?t[e]:void 0:t},this.loglevel=function(e){return l},this.enabled=function(e){return arguments.length?(v!=e&&(v=!!e,l.updateScene(f,!0)),l):v},this.destroy=function(e){window.clearTimeout(o);for(var t=f.length;t--;)f[t].destroy(e);return c.container.removeEventListener("resize",b),c.container.removeEventListener("scroll",b),R.cAF(n),null},function(){for(var e in c)a.hasOwnProperty(e)||delete c[e];if(c.container=R.get.elements(c.container)[0],!c.container)throw"ScrollMagic.Controller init failed.";(p=c.container===window||c.container===document.body||!document.body.contains(c.container))&&(c.container=window),g=y(),c.container.addEventListener("resize",b),c.container.addEventListener("scroll",b);var t=parseInt(c.refreshInterval,10);c.refreshInterval=R.type.Number(t)?t:a.refreshInterval,m()}(),l};var z={defaults:{container:window,vertical:!0,globalSceneOptions:{},loglevel:2,refreshInterval:100}};_.Controller.addOption=function(e,t){z.defaults[e]=t},_.Controller.extend=function(e){var t=this;_.Controller=function(){return t.apply(this,arguments),this.$super=R.extend({},this),e.apply(this,arguments)||this},R.extend(_.Controller,t),_.Controller.prototype=t.prototype,_.Controller.prototype.constructor=_.Controller},_.Scene=function(e){var n,l,c="BEFORE",f="DURING",u="AFTER",r=D.defaults,d=this,h=R.extend({},r,e),p=c,g=0,a={start:0,end:0},v=0,o=!0,s={};this.on=function(e,o){return R.type.Function(o)&&(e=e.trim().split(" ")).forEach(function(e){var t=e.split("."),n=t[0],r=t[1];"*"!=n&&(s[n]||(s[n]=[]),s[n].push({namespace:r||"",callback:o}))}),d},this.off=function(e,i){return e&&(e=e.trim().split(" ")).forEach(function(e,t){var n=e.split("."),r=n[0],o=n[1]||"";("*"===r?Object.keys(s):[r]).forEach(function(e){for(var t=s[e]||[],n=t.length;n--;){var r=t[n];!r||o!==r.namespace&&"*"!==o||i&&i!=r.callback||t.splice(n,1)}t.length||delete s[e]})}),d},this.trigger=function(e,n){var t,r,o,i;return e&&(t=e.trim().split("."),r=t[0],o=t[1],(i=s[r])&&i.forEach(function(e,t){o&&o!==e.namespace||e.callback.call(d,new _.Event(r,e.namespace,d,n))})),d},d.on("change.internal",function(e){"loglevel"!==e.what&&"tweenChanges"!==e.what&&("triggerElement"===e.what?y():"reverse"===e.what&&d.update())}).on("shift.internal",function(e){t(),d.update()}),this.addTo=function(e){return e instanceof _.Controller&&l!=e&&(l&&l.removeScene(d),l=e,E(),i(!0),y(!0),t(),l.info("container").addEventListener("resize",S),e.addScene(d),d.trigger("add",{controller:l}),d.update()),d},this.enabled=function(e){return arguments.length?(o!=e&&(o=!!e,d.update(!0)),d):o},this.remove=function(){var e;return l&&(l.info("container").removeEventListener("resize",S),e=l,l=void 0,e.removeScene(d),d.trigger("remove")),d},this.destroy=function(e){return d.trigger("destroy",{reset:e}),d.remove(),d.off("*.*"),null},this.update=function(e){var t,n;return l&&(e?l.enabled()&&o?(t=l.info("scrollPos"),n=0<h.duration?(t-a.start)/(a.end-a.start):t>=a.start?1:0,d.trigger("update",{startPos:a.start,endPos:a.end,scrollPos:t}),d.progress(n)):m&&p===f&&T(!0):l.updateScene(d,!1)),d},this.refresh=function(){return i(),y(),d},this.progress=function(e){if(arguments.length){var t,n,r,o=!1,i=p,s=l?l.info("scrollDirection"):"PAUSED",a=h.reverse||g<=e;return 0===h.duration?(o=g!=e,p=0===(g=e<1&&a?0:1)?c:f):e<0&&p!==c&&a?(p=c,o=!(g=0)):0<=e&&e<1&&a?(g=e,p=f,o=!0):1<=e&&p!==u?(g=1,p=u,o=!0):p!==f||a||T(),o&&(t={progress:g,state:p,scrollDirection:s},r=function(e){d.trigger(e,t)},(n=p!=i)&&i!==f&&(r("enter"),r(i===c?"start":"end")),r("progress"),n&&p!==f&&(r(p===c?"start":"end"),r("leave"))),d}return g};var m,w,t=function(){a={start:v+h.offset},l&&h.triggerElement&&(a.start-=l.info("size")*h.triggerHook),a.end=a.start+h.duration},i=function(e){var t;!n||x(t="duration",n.call(d))&&!e&&(d.trigger("change",{what:t,newval:h[t]}),d.trigger("shift",{reason:t}))},y=function(e){var t=0,n=h.triggerElement;if(l&&(n||0<v)){if(n)if(n.parentNode){for(var r=l.info(),o=R.get.offset(r.container),i=r.vertical?"top":"left";n.parentNode.hasAttribute(P);)n=n.parentNode;var s=R.get.offset(n);r.isDocument||(o[i]-=l.scrollPos()),t=s[i]-o[i]}else d.triggerElement(void 0);var a=t!=v;v=t,a&&!e&&d.trigger("shift",{reason:"triggerElementPosition"})}},S=function(e){0<h.triggerHook&&d.trigger("shift",{reason:"containerResize"})},b=R.extend(D.validate,{duration:function(t){var e;if(R.type.String(t)&&t.match(/^(\.|\d)*\d+%$/)&&(e=parseFloat(t)/100,t=function(){return l?l.info("size")*e:0}),R.type.Function(t)){n=t;try{t=parseFloat(n.call(d))}catch(e){t=-1}}if(t=parseFloat(t),!R.type.Number(t)||t<0)throw n=n&&void 0,0;return t}}),E=function(e){(e=arguments.length?[e]:Object.keys(b)).forEach(function(t,e){var n;if(b[t])try{n=b[t](h[t])}catch(e){n=r[t]}finally{h[t]=n}})},x=function(e,t){var n=!1,r=h[e];return h[e]!=t&&(h[e]=t,E(e),n=r!=h[e]),n},z=function(t){d[t]||(d[t]=function(e){return arguments.length?("duration"===t&&(n=void 0),x(t,e)&&(d.trigger("change",{what:t,newval:h[t]}),~D.shifts.indexOf(t)&&d.trigger("shift",{reason:t})),d):h[t]})};this.controller=function(){return l},this.state=function(){return p},this.scrollOffset=function(){return a.start},this.triggerPosition=function(){var e=h.offset;return l&&(h.triggerElement?e+=v:e+=l.info("size")*d.triggerHook()),e},d.on("shift.internal",function(e){var t="duration"===e.reason;(p===u&&t||p===f&&0===h.duration)&&T(),t&&A()}).on("progress.internal",function(e){T()}).on("add.internal",function(e){A()}).on("destroy.internal",function(e){d.removePin(e.reset)});function C(){l&&m&&p===f&&!l.info("isDocument")&&T()}function F(){l&&m&&p===f&&((w.relSize.width||w.relSize.autoFullWidth)&&R.get.width(window)!=R.get.width(w.spacer.parentNode)||w.relSize.height&&R.get.height(window)!=R.get.height(w.spacer.parentNode))&&A()}function L(e){l&&m&&p===f&&!l.info("isDocument")&&(e.preventDefault(),l._setScrollPos(l.info("scrollPos")-((e.wheelDelta||e[l.info("vertical")?"wheelDeltaY":"wheelDeltaX"])/3||30*-e.detail)))}var T=function(e){var t,n,r,o,i,s;m&&l&&(t=l.info(),n=w.spacer.firstChild,e||p!==f?(r={position:w.inFlow?"relative":"absolute",top:0,left:0},o=R.css(n,"position")!=r.position,w.pushFollowers?0<h.duration&&(p===u&&0===parseFloat(R.css(w.spacer,"padding-top"))||p===c&&0===parseFloat(R.css(w.spacer,"padding-bottom")))&&(o=!0):r[t.vertical?"top":"left"]=h.duration*g,R.css(n,r),o&&A()):("fixed"!=R.css(n,"position")&&(R.css(n,{position:"fixed"}),A()),i=R.get.offset(w.spacer,!0),s=h.reverse||0===h.duration?t.scrollPos-a.start:Math.round(g*h.duration*10)/10,i[t.vertical?"top":"left"]+=s,R.css(w.spacer.firstChild,{top:i.top,left:i.left})))},A=function(){var e,t,n,r,o;m&&l&&w.inFlow&&(e=p===f,t=l.info("vertical"),n=w.spacer.firstChild,r=R.isMarginCollapseType(R.css(w.spacer,"display")),o={},w.relSize.width||w.relSize.autoFullWidth?e?R.css(m,{width:R.get.width(w.spacer)}):R.css(m,{width:"100%"}):(o["min-width"]=R.get.width(t?m:n,!0,!0),o.width=e?o["min-width"]:"auto"),w.relSize.height?e?R.css(m,{height:R.get.height(w.spacer)-(w.pushFollowers?h.duration:0)}):R.css(m,{height:"100%"}):(o["min-height"]=R.get.height(t?n:m,!0,!r),o.height=e?o["min-height"]:"auto"),w.pushFollowers&&(o["padding"+(t?"Top":"Left")]=h.duration*g,o["padding"+(t?"Bottom":"Right")]=h.duration*(1-g)),R.css(w.spacer,o))};this.setPin=function(e,t){if(t=R.extend({},{pushFollowers:!0,spacerClass:"scrollmagic-pin-spacer"},t),!(e=R.get.elements(e)[0]))return d;if("fixed"===R.css(e,"position"))return d;if(m){if(m===e)return d;d.removePin()}var n=(m=e).parentNode.style.display,r=["top","left","bottom","right","margin","marginLeft","marginRight","marginTop","marginBottom"];m.parentNode.style.display="none";var o="absolute"!=R.css(m,"position"),i=R.css(m,r.concat(["display"])),s=R.css(m,["width","height"]);m.parentNode.style.display=n,!o&&t.pushFollowers&&(t.pushFollowers=!1);var a,l=m.parentNode.insertBefore(document.createElement("div"),m),c=R.extend(i,{position:o?"relative":"absolute",boxSizing:"content-box",mozBoxSizing:"content-box",webkitBoxSizing:"content-box"});return o||R.extend(c,R.css(m,["width","height"])),R.css(l,c),l.setAttribute(P,""),R.addClass(l,t.spacerClass),w={spacer:l,relSize:{width:"%"===s.width.slice(-1),height:"%"===s.height.slice(-1),autoFullWidth:"auto"===s.width&&o&&R.isMarginCollapseType(i.display)},pushFollowers:t.pushFollowers,inFlow:o},m.___origStyle||(m.___origStyle={},a=m.style,r.concat(["width","height","position","boxSizing","mozBoxSizing","webkitBoxSizing"]).forEach(function(e){m.___origStyle[e]=a[e]||""})),w.relSize.width&&R.css(l,{width:s.width}),w.relSize.height&&R.css(l,{height:s.height}),l.appendChild(m),R.css(m,{position:o?"relative":"absolute",margin:"auto",top:"auto",left:"auto",bottom:"auto",right:"auto"}),(w.relSize.width||w.relSize.autoFullWidth)&&R.css(m,{boxSizing:"border-box",mozBoxSizing:"border-box",webkitBoxSizing:"border-box"}),window.addEventListener("scroll",C),window.addEventListener("resize",C),window.addEventListener("resize",F),m.addEventListener("mousewheel",L),m.addEventListener("DOMMouseScroll",L),T(),d},this.removePin=function(e){var t,n,r;return m&&(p===f&&T(!0),!e&&l||((t=w.spacer.firstChild).hasAttribute(P)&&(n=w.spacer.style,r={},["margin","marginLeft","marginRight","marginTop","marginBottom"].forEach(function(e){r[e]=n[e]||""}),R.css(t,r)),w.spacer.parentNode.insertBefore(t,w.spacer),w.spacer.parentNode.removeChild(w.spacer),m.parentNode.hasAttribute(P)||(R.css(m,m.___origStyle),delete m.___origStyle)),window.removeEventListener("scroll",C),window.removeEventListener("resize",C),window.removeEventListener("resize",F),m.removeEventListener("mousewheel",L),m.removeEventListener("DOMMouseScroll",L),m=void 0),d};var N,O=[];return d.on("destroy.internal",function(e){d.removeClassToggle(e.reset)}),this.setClassToggle=function(e,t){var n=R.get.elements(e);return 0!==n.length&&R.type.String(t)&&(0<O.length&&d.removeClassToggle(),N=t,O=n,d.on("enter.internal_class leave.internal_class",function(e){var n="enter"===e.type?R.addClass:R.removeClass;O.forEach(function(e,t){n(e,N)})})),d},this.removeClassToggle=function(e){return e&&O.forEach(function(e,t){R.removeClass(e,N)}),d.off("start.internal_class end.internal_class"),N=void 0,O=[],d},function(){for(var e in h)r.hasOwnProperty(e)||delete h[e];for(var t in r)z(t);E()}(),d};var D={defaults:{duration:0,offset:0,triggerElement:void 0,triggerHook:.5,reverse:!0,loglevel:2},validate:{offset:function(e){if(e=parseFloat(e),!R.type.Number(e))throw 0;return e},triggerElement:function(e){if(e=e||void 0){var t=R.get.elements(e)[0];if(!t||!t.parentNode)throw 0;e=t}return e},triggerHook:function(e){var t={onCenter:.5,onEnter:1,onLeave:0};if(R.type.Number(e))e=Math.max(0,Math.min(parseFloat(e),1));else{if(!(e in t))throw 0;e=t[e]}return e},reverse:function(e){return!!e}},shifts:["duration","offset","triggerHook"]};_.Scene.addOption=function(e,t,n,r){e in D.defaults||(D.defaults[e]=t,D.validate[e]=n,r&&D.shifts.push(e))},_.Scene.extend=function(e){var t=this;_.Scene=function(){return t.apply(this,arguments),this.$super=R.extend({},this),e.apply(this,arguments)||this},R.extend(_.Scene,t),_.Scene.prototype=t.prototype,_.Scene.prototype.constructor=_.Scene},_.Event=function(e,t,n,r){for(var o in r=r||{})this[o]=r[o];return this.type=e,this.target=this.currentTarget=n,this.namespace=t||"",this.timeStamp=this.timestamp=Date.now(),this};var R=_._util=function(s){function a(e){return parseFloat(e)||0}function l(e){return e.currentStyle?e.currentStyle:s.getComputedStyle(e)}function r(e,t,n,r){if((t=t===document?s:t)===s)r=!1;else if(!u.DomElement(t))return 0;e=e[0].toUpperCase()+e.substr(1).toLowerCase();var o,i=(n?t["offset"+e]||t["outer"+e]:t["client"+e]||t["inner"+e])||0;return n&&r&&(o=l(t),i+="Height"===e?a(o.marginTop)+a(o.marginBottom):a(o.marginLeft)+a(o.marginRight)),i}function c(e){return e.replace(/^[^a-z]+([a-z])/g,"$1").replace(/-([a-z])/g,function(e){return e[1].toUpperCase()})}var e={};e.extend=function(e){for(e=e||{},f=1;f<arguments.length;f++)if(arguments[f])for(var t in arguments[f])arguments[f].hasOwnProperty(t)&&(e[t]=arguments[f][t]);return e},e.isMarginCollapseType=function(e){return!!~["block","flex","list-item","table","-webkit-box"].indexOf(e)};for(var o=0,t=["ms","moz","webkit","o"],n=s.requestAnimationFrame,i=s.cancelAnimationFrame,f=0;!n&&f<4;++f)n=s[t[f]+"RequestAnimationFrame"],i=s[t[f]+"CancelAnimationFrame"]||s[t[f]+"CancelRequestAnimationFrame"];n=n||function(e){var t=(new Date).getTime(),n=Math.max(0,16-(t-o)),r=s.setTimeout(function(){e(t+n)},n);return o=t+n,r},i=i||function(e){s.clearTimeout(e)},e.rAF=n.bind(s),e.cAF=i.bind(s);var u=e.type=function(e){return Object.prototype.toString.call(e).replace(/^\[object (.+)\]$/,"$1").toLowerCase()};u.String=function(e){return"string"===u(e)},u.Function=function(e){return"function"===u(e)},u.Array=function(e){return Array.isArray(e)},u.Number=function(e){return!u.Array(e)&&0<=e-parseFloat(e)+1},u.DomElement=function(e){return"object"==typeof HTMLElement||"function"==typeof HTMLElement?e instanceof HTMLElement||e instanceof SVGElement:e&&"object"==typeof e&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName};var d=e.get={};return d.elements=function(e){var t=[];if(u.String(e))try{e=document.querySelectorAll(e)}catch(e){return t}if("nodelist"===u(e)||u.Array(e)||e instanceof NodeList)for(var n=0,r=t.length=e.length;n<r;n++){var o=e[n];t[n]=u.DomElement(o)?o:d.elements(o)}else!u.DomElement(e)&&e!==document&&e!==s||(t=[e]);return t},d.scrollTop=function(e){return e&&"number"==typeof e.scrollTop?e.scrollTop:s.pageYOffset||0},d.scrollLeft=function(e){return e&&"number"==typeof e.scrollLeft?e.scrollLeft:s.pageXOffset||0},d.width=function(e,t,n){return r("width",e,t,n)},d.height=function(e,t,n){return r("height",e,t,n)},d.offset=function(e,t){var n,r={top:0,left:0};return e&&e.getBoundingClientRect&&(n=e.getBoundingClientRect(),r.top=n.top,r.left=n.left,t||(r.top+=d.scrollTop(),r.left+=d.scrollLeft())),r},e.addClass=function(e,t){t&&(e.classList?e.classList.add(t):e.className+=" "+t)},e.removeClass=function(e,t){t&&(e.classList?e.classList.remove(t):e.className=e.className.replace(RegExp("(^|\\b)"+t.split(" ").join("|")+"(\\b|$)","gi")," "))},e.css=function(e,t){if(u.String(t))return l(e)[c(t)];if(u.Array(t)){var n={},r=l(e);return t.forEach(function(e,t){n[e]=r[c(e)]}),n}for(var o in t){var i=t[o];i==parseFloat(i)&&(i+="px"),e.style[c(o)]=i}},e}(window||{});return _});

/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

(function () {
  var container, button, menu, links, i, len;

  container = document.getElementById('site-navigation');
  body = document.getElementsByTagName('body')[0];
  if (!container) {
    return;
  }

  button = document.getElementById('primary-menu-toggle');
  if ('undefined' === typeof button || null === button) {
    return;
  }

  menu = container.getElementsByTagName('ul')[0];

  // Hide menu toggle button if menu is empty and return early.
  if ('undefined' === typeof menu) {
    button.style.display = 'none';
    return;
  }


  menu.setAttribute('aria-expanded', 'false');
  if (-1 === menu.className.indexOf('nav-menu')) {
    menu.className += ' nav-menu';
  }
  button.onclick = function () {
    if ((" " + this.className + " ").replace(/[\n\t]/g, " ").indexOf(" collapse ") > -1) {
      mainMenu = document.getElementById("main-menu-toggle-wrapper");

      if (mainMenu.style.maxHeight){
        mainMenu.style.maxHeight = null;
        container.className = container.className.replace(' toggled', '');
        body.className = body.className.replace(' menu-open', '');
        button.setAttribute('aria-expanded', 'false');
      } else {
        mainMenu.style.maxHeight = mainMenu.scrollHeight + "px";
        body.className += ' menu-open';
        container.className += ' toggled';
        button.setAttribute('aria-expanded', 'true');
      }
    }else {

      if (-1 !== container.className.indexOf('toggled')) {
        container.className = container.className.replace(' toggled', '');
        body.className = body.className.replace(' menu-open', '');
        button.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-expanded', 'false');
      } else {
        body.className += ' menu-open';
        container.className += ' toggled';
        button.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-expanded', 'true');
      }
    }
  };

  // Get all the link elements within the menu.
  links = menu.getElementsByTagName('a');

  // Each time a menu link is focused or blurred, toggle focus.
  for (i = 0, len = links.length; i < len; i++) {
    links[i].addEventListener('focus', toggleFocus, true);
    links[i].addEventListener('blur', toggleFocus, true);
  }

	/**
	 * Sets or removes .focus class on an element.
	 */
  function toggleFocus() {
    var self = this;

    // Move up through the ancestors of the current link until we hit .nav-menu.
    while (-1 === self.className.indexOf('nav-menu')) {

      // On li elements toggle the class .focus.
      if ('li' === self.tagName.toLowerCase()) {
        if (-1 !== self.className.indexOf('focus')) {
          self.className = self.className.replace(' focus', '');
        } else {
          self.className += ' focus';
        }
      }

      self = self.parentElement;
    }
  }

	/**
	 * Toggles `focus` class to allow submenu access on tablets.
	 */
  (function (container) {
    var touchStartFn, i,
      parentLink = container.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

    if ('ontouchstart' in window) {
      touchStartFn = function (e) {
        var menuItem = this.parentNode, i;

        if (!menuItem.classList.contains('focus')) {
          e.preventDefault();
          for (i = 0; i < menuItem.parentNode.children.length; ++i) {
            if (menuItem === menuItem.parentNode.children[i]) {
              continue;
            }
            menuItem.parentNode.children[i].classList.remove('focus');
          }
          menuItem.classList.add('focus');
        } else {
          menuItem.classList.remove('focus');
        }
      };

      for (i = 0; i < parentLink.length; ++i) {
        parentLink[i].addEventListener('touchstart', touchStartFn, false);
      }
    }
  }(container));
})();


!function n(i,s,a){function r(e,t){if(!s[e]){if(!i[e]){var o="function"==typeof require&&require;if(!t&&o)return o(e,!0);if(l)return l(e,!0);throw(t=new Error("Cannot find module '"+e+"'")).code="MODULE_NOT_FOUND",t}o=s[e]={exports:{}},i[e][0].call(o.exports,function(t){return r(i[e][1][t]||t)},o,o.exports,n,i,s,a)}return s[e].exports}for(var l="function"==typeof require&&require,t=0;t<a.length;t++)r(a[t]);return r}({1:[function(t,e,o){!function(e){!function(){"use strict";function h(t){return(h="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function f(t,e){var o,n,i,s,a="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(a)return n=!(o=!0),{s:function(){a=a.call(t)},n:function(){var t=a.next();return o=t.done,t},e:function(t){n=!0,i=t},f:function(){try{o||null==a.return||a.return()}finally{if(n)throw i}}};if(Array.isArray(t)||(a=r(t))||e&&t&&"number"==typeof t.length)return a&&(t=a),s=0,{s:e=function(){},n:function(){return s>=t.length?{done:!0}:{done:!1,value:t[s++]}},e:function(t){throw t},f:e};throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function n(t){return function(t){if(Array.isArray(t))return i(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||r(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function r(t,e){var o;if(t)return"string"==typeof t?i(t,e):"Map"===(o="Object"===(o=Object.prototype.toString.call(t).slice(8,-1))&&t.constructor?t.constructor.name:o)||"Set"===o?Array.from(t):"Arguments"===o||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)?i(t,e):void 0}function i(t,e){(null==e||e>t.length)&&(e=t.length);for(var o=0,n=new Array(e);o<e;o++)n[o]=t[o];return n}function s(t,e){for(var o=0;o<e.length;o++){var n=e[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function a(t,e,o){e in t?Object.defineProperty(t,e,{value:o,enumerable:!0,configurable:!0,writable:!0}):t[e]=o}Object.defineProperty(o,"__esModule",{value:!0}),o.default=void 0;var t=function(){function i(t,e){var o,n=this;if(!(this instanceof i))throw new TypeError("Cannot call a class as a function");a(this,"defaultOptions",{sourceAttr:"href",overlay:!0,overlayOpacity:.7,spinner:!0,nav:!0,navText:["&lsaquo;","&rsaquo;"],captions:!0,captionDelay:0,captionSelector:"img",captionType:"attr",captionsData:"title",captionPosition:"bottom",captionClass:"",captionHTML:!0,close:!0,closeText:"&times;",swipeClose:!0,showCounter:!0,fileExt:"png|jpg|jpeg|gif|webp",animationSlide:!0,animationSpeed:250,preloading:!0,enableKeyboard:!0,loop:!0,rel:!1,docClose:!0,swipeTolerance:50,className:"simple-lightbox",widthRatio:.8,heightRatio:.9,scaleImageToRatio:!1,disableRightClick:!1,disableScroll:!0,alertError:!0,alertErrorMessage:"Image not found, next image will be loaded",additionalHtml:!1,history:!0,throttleInterval:0,doubleTapZoom:2,maxZoom:10,htmlClass:"has-lightbox",rtl:!1,fixedClass:"sl-fixed",fadeSpeed:300,uniqueImages:!0,focus:!0,scrollZoom:!0,scrollZoomFactor:.5,download:!1}),a(this,"transitionPrefix",void 0),a(this,"isPassiveEventsSupported",void 0),a(this,"transitionCapable",!1),a(this,"isTouchDevice","ontouchstart"in window),a(this,"isAppleDevice",/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)),a(this,"initialLocationHash",void 0),a(this,"pushStateSupport","pushState"in history),a(this,"isOpen",!1),a(this,"isAnimating",!1),a(this,"isClosing",!1),a(this,"isFadeIn",!1),a(this,"urlChangedOnce",!1),a(this,"hashReseted",!1),a(this,"historyHasChanges",!1),a(this,"historyUpdateTimeout",null),a(this,"currentImage",void 0),a(this,"eventNamespace","simplelightbox"),a(this,"domNodes",{}),a(this,"loadedImages",[]),a(this,"initialImageIndex",0),a(this,"currentImageIndex",0),a(this,"initialSelector",null),a(this,"globalScrollbarWidth",0),a(this,"controlCoordinates",{swipeDiff:0,swipeYDiff:0,swipeStart:0,swipeEnd:0,swipeYStart:0,swipeYEnd:0,mousedown:!1,imageLeft:0,zoomed:!1,containerHeight:0,containerWidth:0,containerOffsetX:0,containerOffsetY:0,imgHeight:0,imgWidth:0,capture:!1,initialOffsetX:0,initialOffsetY:0,initialPointerOffsetX:0,initialPointerOffsetY:0,initialPointerOffsetX2:0,initialPointerOffsetY2:0,initialScale:1,initialPinchDistance:0,pointerOffsetX:0,pointerOffsetY:0,pointerOffsetX2:0,pointerOffsetY2:0,targetOffsetX:0,targetOffsetY:0,targetScale:0,pinchOffsetX:0,pinchOffsetY:0,limitOffsetX:0,limitOffsetY:0,scaleDifference:0,targetPinchDistance:0,touchCount:0,doubleTapped:!1,touchmoveCount:0}),this.options=Object.assign(this.defaultOptions,e),this.isPassiveEventsSupported=this.checkPassiveEventsSupport(),"string"==typeof t?(this.initialSelector=t,this.elements=Array.from(document.querySelectorAll(t))):this.elements=void 0!==t.length&&0<t.length?Array.from(t):[t],this.relatedElements=[],this.transitionPrefix=this.calculateTransitionPrefix(),this.transitionCapable=!1!==this.transitionPrefix,this.initialLocationHash=this.hash,this.options.rel&&(this.elements=this.getRelated(this.options.rel)),this.options.uniqueImages&&(o=[],this.elements=Array.from(this.elements).filter(function(t){t=t.getAttribute(n.options.sourceAttr);return-1===o.indexOf(t)&&(o.push(t),!0)})),this.createDomNodes(),this.options.close&&this.domNodes.wrapper.appendChild(this.domNodes.closeButton),this.options.nav&&this.domNodes.wrapper.appendChild(this.domNodes.navigation),this.options.spinner&&this.domNodes.wrapper.appendChild(this.domNodes.spinner),this.addEventListener(this.elements,"click."+this.eventNamespace,function(t){if(n.isValidLink(t.currentTarget)){if(t.preventDefault(),n.isAnimating)return!1;n.initialImageIndex=n.elements.indexOf(t.currentTarget),n.openImage(t.currentTarget)}}),this.options.docClose&&this.addEventListener(this.domNodes.wrapper,["click."+this.eventNamespace,"touchstart."+this.eventNamespace],function(t){n.isOpen&&t.target===t.currentTarget&&n.close()}),this.options.disableRightClick&&this.addEventListener(document.body,"contextmenu."+this.eventNamespace,function(t){t.target.parentElement.classList.contains("sl-image")&&t.preventDefault()}),this.options.enableKeyboard&&this.addEventListener(document.body,"keyup."+this.eventNamespace,this.throttle(function(t){n.controlCoordinates.swipeDiff=0,n.isAnimating&&"Escape"===t.key?(n.currentImage.setAttribute("src",""),n.isAnimating=!1,n.close()):n.isOpen&&(t.preventDefault(),"Escape"===t.key&&n.close(),!n.isAnimating&&-1<["ArrowLeft","ArrowRight"].indexOf(t.key)&&n.loadImage("ArrowRight"===t.key?1:-1))},this.options.throttleInterval)),this.addEvents()}var t,e,o;return t=i,(e=[{key:"checkPassiveEventsSupport",value:function(){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}catch(t){}return t}},{key:"getCaptionElement",value:function(t){var e,o;return this.options.captionSelector.startsWith("+")?(o=this.options.captionSelector.replace(/^\+/,"").trimStart(),!(!(e=t.nextElementSibling)||!e.matches(o))&&e):this.options.captionSelector.startsWith(">")?(o=this.options.captionSelector.replace(/^>/,"").trimStart(),t.querySelector(o)):t.querySelector(this.options.captionSelector)}},{key:"generateQuerySelector",value:function(t){var e=t.tagName,o=t.id,n=t.className,i=t.parentNode;if("HTML"===e)return"HTML";var s=e;if(s+=""!==o?"#".concat(o):"",n)for(var a=n.trim().split(/\s/),r=0;r<a.length;r++)s+=".".concat(a[r]);for(var l=1,d=t;d.previousElementSibling;d=d.previousElementSibling)l+=1;return s+=":nth-child(".concat(l,")"),"".concat(this.generateQuerySelector(i)," > ").concat(s)}},{key:"createDomNodes",value:function(){var t,e;this.domNodes.overlay=document.createElement("div"),this.domNodes.overlay.classList.add("sl-overlay"),this.domNodes.overlay.dataset.opacityTarget=this.options.overlayOpacity,this.domNodes.closeButton=document.createElement("button"),this.domNodes.closeButton.classList.add("sl-close"),this.domNodes.closeButton.innerHTML=this.options.closeText,this.domNodes.spinner=document.createElement("div"),this.domNodes.spinner.classList.add("sl-spinner"),this.domNodes.spinner.innerHTML="<div></div>",this.domNodes.navigation=document.createElement("div"),this.domNodes.navigation.classList.add("sl-navigation"),this.domNodes.navigation.innerHTML='<button class="sl-prev">'.concat(this.options.navText[0],'</button><button class="sl-next">').concat(this.options.navText[1],"</button>"),this.domNodes.counter=document.createElement("div"),this.domNodes.counter.classList.add("sl-counter"),this.domNodes.counter.innerHTML='<span class="sl-current"></span>/<span class="sl-total"></span>',this.domNodes.download=document.createElement("div"),this.domNodes.download.classList.add("sl-download"),this.domNodes.downloadLink=document.createElement("a"),this.domNodes.downloadLink.setAttribute("download",""),this.domNodes.downloadLink.textContent=this.options.download,this.domNodes.download.appendChild(this.domNodes.downloadLink),this.domNodes.caption=document.createElement("div"),this.domNodes.caption.classList.add("sl-caption","pos-"+this.options.captionPosition),this.options.captionClass&&(e=this.options.captionClass.split(/[\s,]+/),(t=this.domNodes.caption.classList).add.apply(t,n(e))),this.domNodes.image=document.createElement("div"),this.domNodes.image.classList.add("sl-image"),this.domNodes.wrapper=document.createElement("div"),this.domNodes.wrapper.classList.add("sl-wrapper"),this.domNodes.wrapper.setAttribute("tabindex",-1),this.domNodes.wrapper.setAttribute("role","dialog"),this.domNodes.wrapper.setAttribute("aria-hidden",!1),this.options.className&&this.domNodes.wrapper.classList.add(this.options.className),this.options.rtl&&this.domNodes.wrapper.classList.add("sl-dir-rtl")}},{key:"throttle",value:function(t,e){var o;return function(){o||(t.apply(this,arguments),o=!0,setTimeout(function(){return o=!1},e))}}},{key:"isValidLink",value:function(t){return!this.options.fileExt||t.getAttribute(this.options.sourceAttr)&&new RegExp("("+this.options.fileExt+")($|\\?.*$)","i").test(t.getAttribute(this.options.sourceAttr))}},{key:"calculateTransitionPrefix",value:function(){var t=(document.body||document.documentElement).style;return"transition"in t?"":"WebkitTransition"in t?"-webkit-":"MozTransition"in t?"-moz-":"OTransition"in t&&"-o"}},{key:"getScrollbarWidth",value:function(){var t,e=document.createElement("div");return e.classList.add("sl-scrollbar-measure"),document.body.appendChild(e),t=e.offsetWidth-e.clientWidth,document.body.removeChild(e),t}},{key:"toggleScrollbar",value:function(t){var e,n=0,o=[].slice.call(document.querySelectorAll("."+this.options.fixedClass));return"hide"===t?((t=window.innerWidth)||(t=(e=document.documentElement.getBoundingClientRect()).right-Math.abs(e.left)),(document.body.clientWidth<t||this.isAppleDevice)&&(e=parseInt(window.getComputedStyle(document.body).paddingRight||0,10),n=this.getScrollbarWidth(),document.body.dataset.originalPaddingRight=e,(0<n||0==n&&this.isAppleDevice)&&(document.body.classList.add("hidden-scroll"),document.body.style.paddingRight=e+n+"px",o.forEach(function(t){var e=t.style.paddingRight,o=window.getComputedStyle(t)["padding-right"];t.dataset.originalPaddingRight=e,t.style.paddingRight="".concat(parseFloat(o)+n,"px")})))):(document.body.classList.remove("hidden-scroll"),document.body.style.paddingRight=document.body.dataset.originalPaddingRight+"px",o.forEach(function(t){var e=t.dataset.originalPaddingRight;void 0!==e&&(t.style.paddingRight=e)})),n}},{key:"close",value:function(){var t=this;if(!this.isOpen||this.isAnimating||this.isClosing)return!1;this.isClosing=!0;var e,o=this.relatedElements[this.currentImageIndex];for(e in o.dispatchEvent(new Event("close.simplelightbox")),this.options.history&&(this.historyHasChanges=!1,this.hashReseted||this.resetHash()),this.removeEventListener(document,"focusin."+this.eventNamespace),this.fadeOut(this.domNodes.overlay,this.options.fadeSpeed),this.fadeOut(document.querySelectorAll(".sl-image img,  .sl-close, .sl-navigation, .sl-image .sl-caption, .sl-counter"),this.options.fadeSpeed,function(){t.options.disableScroll&&t.toggleScrollbar("show"),t.options.htmlClass&&""!==t.options.htmlClass&&document.querySelector("html").classList.remove(t.options.htmlClass),document.body.removeChild(t.domNodes.wrapper),t.options.overlay&&document.body.removeChild(t.domNodes.overlay),t.domNodes.additionalHtml=null,t.domNodes.download=null,o.dispatchEvent(new Event("closed.simplelightbox")),t.isClosing=!1}),this.currentImage=null,this.isOpen=!1,this.isAnimating=!1,this.controlCoordinates)this.controlCoordinates[e]=0;this.controlCoordinates.mousedown=!1,this.controlCoordinates.zoomed=!1,this.controlCoordinates.capture=!1,this.controlCoordinates.initialScale=this.minMax(1,1,this.options.maxZoom),this.controlCoordinates.doubleTapped=!1}},{key:"hash",get:function(){return window.location.hash.substring(1)}},{key:"preload",value:function(){var e=this,o=this.currentImageIndex,t=this.relatedElements.length,n=o+1<0?t-1:t-1<=o+1?0:o+1,t=o-1<0?t-1:t-1<=o-1?0:o-1,i=new Image,s=new Image;i.addEventListener("load",function(t){t=t.target.getAttribute("src");-1===e.loadedImages.indexOf(t)&&e.loadedImages.push(t),e.relatedElements[o].dispatchEvent(new Event("nextImageLoaded."+e.eventNamespace))}),i.setAttribute("src",this.relatedElements[n].getAttribute(this.options.sourceAttr)),s.addEventListener("load",function(t){t=t.target.getAttribute("src");-1===e.loadedImages.indexOf(t)&&e.loadedImages.push(t),e.relatedElements[o].dispatchEvent(new Event("prevImageLoaded."+e.eventNamespace))}),s.setAttribute("src",this.relatedElements[t].getAttribute(this.options.sourceAttr))}},{key:"loadImage",value:function(t){var e=this,o=t,t=(this.options.rtl&&(t=-t),this.relatedElements[this.currentImageIndex].dispatchEvent(new Event("change."+this.eventNamespace)),this.relatedElements[this.currentImageIndex].dispatchEvent(new Event((1===t?"next":"prev")+"."+this.eventNamespace)),this.currentImageIndex+t);if(this.isAnimating||(t<0||t>=this.relatedElements.length)&&!1===this.options.loop)return!1;this.currentImageIndex=t<0?this.relatedElements.length-1:t>this.relatedElements.length-1?0:t,this.domNodes.counter.querySelector(".sl-current").innerHTML=this.currentImageIndex+1,this.options.animationSlide&&this.slide(this.options.animationSpeed/1e3,-100*o-this.controlCoordinates.swipeDiff+"px"),this.fadeOut(this.domNodes.image,this.options.fadeSpeed,function(){e.isAnimating=!0,e.isClosing?e.isAnimating=!1:setTimeout(function(){var t=e.relatedElements[e.currentImageIndex];e.currentImage&&(e.currentImage.setAttribute("src",t.getAttribute(e.options.sourceAttr)),-1===e.loadedImages.indexOf(t.getAttribute(e.options.sourceAttr))&&e.show(e.domNodes.spinner),e.domNodes.image.contains(e.domNodes.caption)&&e.domNodes.image.removeChild(e.domNodes.caption),e.adjustImage(o),e.options.preloading&&e.preload())},100)})}},{key:"adjustImage",value:function(s){var a=this;if(!this.currentImage)return!1;var t=new Image,r=window.innerWidth*this.options.widthRatio,l=window.innerHeight*this.options.heightRatio;t.setAttribute("src",this.currentImage.getAttribute("src")),this.currentImage.dataset.scale=1,this.currentImage.dataset.translateX=0,this.currentImage.dataset.translateY=0,this.zoomPanElement(0,0,1),t.addEventListener("error",function(t){a.relatedElements[a.currentImageIndex].dispatchEvent(new Event("error."+a.eventNamespace)),a.isAnimating=!1,a.isOpen=!0,a.domNodes.spinner.style.display="none";var e=1===s||-1===s;if(a.initialImageIndex===a.currentImageIndex&&e)return a.close();a.options.alertError&&alert(a.options.alertErrorMessage),a.loadImage(e?s:1)}),t.addEventListener("load",function(t){void 0!==s&&(a.relatedElements[a.currentImageIndex].dispatchEvent(new Event("changed."+a.eventNamespace)),a.relatedElements[a.currentImageIndex].dispatchEvent(new Event((1===s?"nextDone":"prevDone")+"."+a.eventNamespace))),a.options.history&&a.updateURL(),-1===a.loadedImages.indexOf(a.currentImage.getAttribute("src"))&&a.loadedImages.push(a.currentImage.getAttribute("src"));var e,o,n,i=t.target.width,t=t.target.height;(a.options.scaleImageToRatio||r<i||l<t)&&(i/=e=r/l<i/t?i/r:t/l,t/=e),a.domNodes.image.style.top=(window.innerHeight-t)/2+"px",a.domNodes.image.style.left=(window.innerWidth-i-a.globalScrollbarWidth)/2+"px",a.domNodes.image.style.width=i+"px",a.domNodes.image.style.height=t+"px",a.domNodes.spinner.style.display="none",a.options.focus&&a.forceFocus(),a.fadeIn(a.currentImage,a.options.fadeSpeed,function(){a.options.focus&&a.domNodes.wrapper.focus()}),a.isOpen=!0,"string"==typeof a.options.captionSelector?o="self"===a.options.captionSelector?a.relatedElements[a.currentImageIndex]:a.getCaptionElement(a.relatedElements[a.currentImageIndex]):"function"==typeof a.options.captionSelector&&(o=a.options.captionSelector(a.relatedElements[a.currentImageIndex])),a.options.captions&&o&&(n="data"===a.options.captionType?o.dataset[a.options.captionsData]:"text"===a.options.captionType?o.innerHTML:o.getAttribute(a.options.captionsData)),a.options.loop?1===a.relatedElements.length?a.hide(a.domNodes.navigation.querySelectorAll(".sl-prev, .sl-next")):a.show(a.domNodes.navigation.querySelectorAll(".sl-prev, .sl-next")):(0===a.currentImageIndex&&a.hide(a.domNodes.navigation.querySelector(".sl-prev")),a.currentImageIndex>=a.relatedElements.length-1&&a.hide(a.domNodes.navigation.querySelector(".sl-next")),0<a.currentImageIndex&&a.show(a.domNodes.navigation.querySelector(".sl-prev")),a.currentImageIndex<a.relatedElements.length-1&&a.show(a.domNodes.navigation.querySelector(".sl-next"))),1===s||-1===s?(a.options.animationSlide&&(a.slide(0,100*s+"px"),setTimeout(function(){a.slide(a.options.animationSpeed/1e3,"0px")},50)),a.fadeIn(a.domNodes.image,a.options.fadeSpeed,function(){a.isAnimating=!1,a.setCaption(n,i)})):(a.isAnimating=!1,a.setCaption(n,i)),a.options.additionalHtml&&!a.domNodes.additionalHtml&&(a.domNodes.additionalHtml=document.createElement("div"),a.domNodes.additionalHtml.classList.add("sl-additional-html"),a.domNodes.additionalHtml.innerHTML=a.options.additionalHtml,a.domNodes.image.appendChild(a.domNodes.additionalHtml)),a.options.download&&a.domNodes.downloadLink.setAttribute("href",a.currentImage.getAttribute("src"))})}},{key:"zoomPanElement",value:function(t,e,o){this.currentImage.style[this.transitionPrefix+"transform"]="translate("+t+","+e+") scale("+o+")"}},{key:"minMax",value:function(t,e,o){return t<e?e:o<t?o:t}},{key:"setZoomData",value:function(t,e,o){this.currentImage.dataset.scale=t,this.currentImage.dataset.translateX=e,this.currentImage.dataset.translateY=o}},{key:"hashchangeHandler",value:function(){this.isOpen&&this.hash===this.initialLocationHash&&(this.hashReseted=!0,this.close())}},{key:"addEvents",value:function(){var o,n=this;this.addEventListener(window,"resize."+this.eventNamespace,function(t){n.isOpen&&n.adjustImage()}),this.addEventListener(this.domNodes.closeButton,["click."+this.eventNamespace,"touchstart."+this.eventNamespace],this.close.bind(this)),this.options.history&&setTimeout(function(){n.addEventListener(window,"hashchange."+n.eventNamespace,function(t){n.isOpen&&n.hashchangeHandler()})},40),this.addEventListener(this.domNodes.navigation.getElementsByTagName("button"),"click."+this.eventNamespace,function(t){if(!t.currentTarget.tagName.match(/button/i))return!0;t.preventDefault(),n.controlCoordinates.swipeDiff=0,n.loadImage(t.currentTarget.classList.contains("sl-next")?1:-1)}),this.options.scrollZoom&&(o=1,this.addEventListener(this.domNodes.image,["mousewheel","DOMMouseScroll"],function(t){if(n.controlCoordinates.mousedown||n.isAnimating||n.isClosing||!n.isOpen)return!0;0==n.controlCoordinates.containerHeight&&(n.controlCoordinates.containerHeight=n.getDimensions(n.domNodes.image).height,n.controlCoordinates.containerWidth=n.getDimensions(n.domNodes.image).width,n.controlCoordinates.imgHeight=n.getDimensions(n.currentImage).height,n.controlCoordinates.imgWidth=n.getDimensions(n.currentImage).width,n.controlCoordinates.containerOffsetX=n.domNodes.image.offsetLeft,n.controlCoordinates.containerOffsetY=n.domNodes.image.offsetTop,n.controlCoordinates.initialOffsetX=parseFloat(n.currentImage.dataset.translateX),n.controlCoordinates.initialOffsetY=parseFloat(n.currentImage.dataset.translateY));var e=t.delta||t.wheelDelta,e=(void 0===e&&(e=t.detail),e=Math.max(-1,Math.min(1,e)),o+=e*n.options.scrollZoomFactor*o,o=Math.max(1,Math.min(n.options.maxZoom,o)),n.controlCoordinates.targetScale=o,document.documentElement.scrollTop||document.body.scrollTop);n.controlCoordinates.pinchOffsetX=t.pageX,n.controlCoordinates.pinchOffsetY=t.pageY-e||0,n.controlCoordinates.limitOffsetX=(n.controlCoordinates.imgWidth*n.controlCoordinates.targetScale-n.controlCoordinates.containerWidth)/2,n.controlCoordinates.limitOffsetY=(n.controlCoordinates.imgHeight*n.controlCoordinates.targetScale-n.controlCoordinates.containerHeight)/2,n.controlCoordinates.scaleDifference=n.controlCoordinates.targetScale-n.controlCoordinates.initialScale,n.controlCoordinates.targetOffsetX=n.controlCoordinates.imgWidth*n.controlCoordinates.targetScale<=n.controlCoordinates.containerWidth?0:n.minMax(n.controlCoordinates.initialOffsetX-(n.controlCoordinates.pinchOffsetX-n.controlCoordinates.containerOffsetX-n.controlCoordinates.containerWidth/2-n.controlCoordinates.initialOffsetX)/(n.controlCoordinates.targetScale-n.controlCoordinates.scaleDifference)*n.controlCoordinates.scaleDifference,-1*n.controlCoordinates.limitOffsetX,n.controlCoordinates.limitOffsetX),n.controlCoordinates.targetOffsetY=n.controlCoordinates.imgHeight*n.controlCoordinates.targetScale<=n.controlCoordinates.containerHeight?0:n.minMax(n.controlCoordinates.initialOffsetY-(n.controlCoordinates.pinchOffsetY-n.controlCoordinates.containerOffsetY-n.controlCoordinates.containerHeight/2-n.controlCoordinates.initialOffsetY)/(n.controlCoordinates.targetScale-n.controlCoordinates.scaleDifference)*n.controlCoordinates.scaleDifference,-1*n.controlCoordinates.limitOffsetY,n.controlCoordinates.limitOffsetY),n.zoomPanElement(n.controlCoordinates.targetOffsetX+"px",n.controlCoordinates.targetOffsetY+"px",n.controlCoordinates.targetScale),1<n.controlCoordinates.targetScale?(n.controlCoordinates.zoomed=!0,(!n.domNodes.caption.style.opacity||0<n.domNodes.caption.style.opacity)&&"none"!==n.domNodes.caption.style.display&&n.fadeOut(n.domNodes.caption,n.options.fadeSpeed)):(1===n.controlCoordinates.initialScale&&(n.controlCoordinates.zoomed=!1,"none"===n.domNodes.caption.style.display&&n.fadeIn(n.domNodes.caption,n.options.fadeSpeed)),n.controlCoordinates.initialPinchDistance=null,n.controlCoordinates.capture=!1),n.controlCoordinates.initialPinchDistance=n.controlCoordinates.targetPinchDistance,n.controlCoordinates.initialScale=n.controlCoordinates.targetScale,n.controlCoordinates.initialOffsetX=n.controlCoordinates.targetOffsetX,n.controlCoordinates.initialOffsetY=n.controlCoordinates.targetOffsetY,n.setZoomData(n.controlCoordinates.targetScale,n.controlCoordinates.targetOffsetX,n.controlCoordinates.targetOffsetY),n.zoomPanElement(n.controlCoordinates.targetOffsetX+"px",n.controlCoordinates.targetOffsetY+"px",n.controlCoordinates.targetScale)})),this.addEventListener(this.domNodes.image,["touchstart."+this.eventNamespace,"mousedown."+this.eventNamespace],function(t){if("A"===t.target.tagName&&"touchstart"===t.type)return!0;if("mousedown"===t.type)t.preventDefault(),n.controlCoordinates.initialPointerOffsetX=t.clientX,n.controlCoordinates.initialPointerOffsetY=t.clientY,n.controlCoordinates.containerHeight=n.getDimensions(n.domNodes.image).height,n.controlCoordinates.containerWidth=n.getDimensions(n.domNodes.image).width,n.controlCoordinates.imgHeight=n.getDimensions(n.currentImage).height,n.controlCoordinates.imgWidth=n.getDimensions(n.currentImage).width,n.controlCoordinates.containerOffsetX=n.domNodes.image.offsetLeft,n.controlCoordinates.containerOffsetY=n.domNodes.image.offsetTop,n.controlCoordinates.initialOffsetX=parseFloat(n.currentImage.dataset.translateX),n.controlCoordinates.initialOffsetY=parseFloat(n.currentImage.dataset.translateY);else if(n.controlCoordinates.touchCount=t.touches.length,n.controlCoordinates.initialPointerOffsetX=t.touches[0].clientX,n.controlCoordinates.initialPointerOffsetY=t.touches[0].clientY,n.controlCoordinates.containerHeight=n.getDimensions(n.domNodes.image).height,n.controlCoordinates.containerWidth=n.getDimensions(n.domNodes.image).width,n.controlCoordinates.imgHeight=n.getDimensions(n.currentImage).height,n.controlCoordinates.imgWidth=n.getDimensions(n.currentImage).width,n.controlCoordinates.containerOffsetX=n.domNodes.image.offsetLeft,n.controlCoordinates.containerOffsetY=n.domNodes.image.offsetTop,1===n.controlCoordinates.touchCount){if(n.controlCoordinates.doubleTapped)return n.currentImage.classList.add("sl-transition"),n.controlCoordinates.zoomed?(n.controlCoordinates.initialScale=1,n.setZoomData(n.controlCoordinates.initialScale,0,0),n.zoomPanElement("0px","0px",n.controlCoordinates.initialScale),n.controlCoordinates.zoomed=!1):(n.controlCoordinates.initialScale=n.options.doubleTapZoom,n.setZoomData(n.controlCoordinates.initialScale,0,0),n.zoomPanElement("0px","0px",n.controlCoordinates.initialScale),(!n.domNodes.caption.style.opacity||0<n.domNodes.caption.style.opacity)&&"none"!==n.domNodes.caption.style.display&&n.fadeOut(n.domNodes.caption,n.options.fadeSpeed),n.controlCoordinates.zoomed=!0),setTimeout(function(){n.currentImage&&n.currentImage.classList.remove("sl-transition")},200),!1;n.controlCoordinates.doubleTapped=!0,setTimeout(function(){n.controlCoordinates.doubleTapped=!1},300),n.controlCoordinates.initialOffsetX=parseFloat(n.currentImage.dataset.translateX),n.controlCoordinates.initialOffsetY=parseFloat(n.currentImage.dataset.translateY)}else 2===n.controlCoordinates.touchCount&&(n.controlCoordinates.initialPointerOffsetX2=t.touches[1].clientX,n.controlCoordinates.initialPointerOffsetY2=t.touches[1].clientY,n.controlCoordinates.initialOffsetX=parseFloat(n.currentImage.dataset.translateX),n.controlCoordinates.initialOffsetY=parseFloat(n.currentImage.dataset.translateY),n.controlCoordinates.pinchOffsetX=(n.controlCoordinates.initialPointerOffsetX+n.controlCoordinates.initialPointerOffsetX2)/2,n.controlCoordinates.pinchOffsetY=(n.controlCoordinates.initialPointerOffsetY+n.controlCoordinates.initialPointerOffsetY2)/2,n.controlCoordinates.initialPinchDistance=Math.sqrt((n.controlCoordinates.initialPointerOffsetX-n.controlCoordinates.initialPointerOffsetX2)*(n.controlCoordinates.initialPointerOffsetX-n.controlCoordinates.initialPointerOffsetX2)+(n.controlCoordinates.initialPointerOffsetY-n.controlCoordinates.initialPointerOffsetY2)*(n.controlCoordinates.initialPointerOffsetY-n.controlCoordinates.initialPointerOffsetY2)));return n.controlCoordinates.capture=!0,!!n.controlCoordinates.mousedown||(n.transitionCapable&&(n.controlCoordinates.imageLeft=parseInt(n.domNodes.image.style.left,10)),n.controlCoordinates.mousedown=!0,n.controlCoordinates.swipeDiff=0,n.controlCoordinates.swipeYDiff=0,n.controlCoordinates.swipeStart=t.pageX||t.touches[0].pageX,n.controlCoordinates.swipeYStart=t.pageY||t.touches[0].pageY,!1)}),this.addEventListener(this.domNodes.image,["touchmove."+this.eventNamespace,"mousemove."+this.eventNamespace,"MSPointerMove"],function(t){if(!n.controlCoordinates.mousedown)return!0;if("touchmove"===t.type){if(!1===n.controlCoordinates.capture)return!1;n.controlCoordinates.pointerOffsetX=t.touches[0].clientX,n.controlCoordinates.pointerOffsetY=t.touches[0].clientY,n.controlCoordinates.touchCount=t.touches.length,n.controlCoordinates.touchmoveCount++,1<n.controlCoordinates.touchCount?(n.controlCoordinates.pointerOffsetX2=t.touches[1].clientX,n.controlCoordinates.pointerOffsetY2=t.touches[1].clientY,n.controlCoordinates.targetPinchDistance=Math.sqrt((n.controlCoordinates.pointerOffsetX-n.controlCoordinates.pointerOffsetX2)*(n.controlCoordinates.pointerOffsetX-n.controlCoordinates.pointerOffsetX2)+(n.controlCoordinates.pointerOffsetY-n.controlCoordinates.pointerOffsetY2)*(n.controlCoordinates.pointerOffsetY-n.controlCoordinates.pointerOffsetY2)),null===n.controlCoordinates.initialPinchDistance&&(n.controlCoordinates.initialPinchDistance=n.controlCoordinates.targetPinchDistance),1<=Math.abs(n.controlCoordinates.initialPinchDistance-n.controlCoordinates.targetPinchDistance)&&(n.controlCoordinates.targetScale=n.minMax(n.controlCoordinates.targetPinchDistance/n.controlCoordinates.initialPinchDistance*n.controlCoordinates.initialScale,1,n.options.maxZoom),n.controlCoordinates.limitOffsetX=(n.controlCoordinates.imgWidth*n.controlCoordinates.targetScale-n.controlCoordinates.containerWidth)/2,n.controlCoordinates.limitOffsetY=(n.controlCoordinates.imgHeight*n.controlCoordinates.targetScale-n.controlCoordinates.containerHeight)/2,n.controlCoordinates.scaleDifference=n.controlCoordinates.targetScale-n.controlCoordinates.initialScale,n.controlCoordinates.targetOffsetX=n.controlCoordinates.imgWidth*n.controlCoordinates.targetScale<=n.controlCoordinates.containerWidth?0:n.minMax(n.controlCoordinates.initialOffsetX-(n.controlCoordinates.pinchOffsetX-n.controlCoordinates.containerOffsetX-n.controlCoordinates.containerWidth/2-n.controlCoordinates.initialOffsetX)/(n.controlCoordinates.targetScale-n.controlCoordinates.scaleDifference)*n.controlCoordinates.scaleDifference,-1*n.controlCoordinates.limitOffsetX,n.controlCoordinates.limitOffsetX),n.controlCoordinates.targetOffsetY=n.controlCoordinates.imgHeight*n.controlCoordinates.targetScale<=n.controlCoordinates.containerHeight?0:n.minMax(n.controlCoordinates.initialOffsetY-(n.controlCoordinates.pinchOffsetY-n.controlCoordinates.containerOffsetY-n.controlCoordinates.containerHeight/2-n.controlCoordinates.initialOffsetY)/(n.controlCoordinates.targetScale-n.controlCoordinates.scaleDifference)*n.controlCoordinates.scaleDifference,-1*n.controlCoordinates.limitOffsetY,n.controlCoordinates.limitOffsetY),n.zoomPanElement(n.controlCoordinates.targetOffsetX+"px",n.controlCoordinates.targetOffsetY+"px",n.controlCoordinates.targetScale),1<n.controlCoordinates.targetScale&&(n.controlCoordinates.zoomed=!0,(!n.domNodes.caption.style.opacity||0<n.domNodes.caption.style.opacity)&&"none"!==n.domNodes.caption.style.display&&n.fadeOut(n.domNodes.caption,n.options.fadeSpeed)),n.controlCoordinates.initialPinchDistance=n.controlCoordinates.targetPinchDistance,n.controlCoordinates.initialScale=n.controlCoordinates.targetScale,n.controlCoordinates.initialOffsetX=n.controlCoordinates.targetOffsetX,n.controlCoordinates.initialOffsetY=n.controlCoordinates.targetOffsetY)):(n.controlCoordinates.targetScale=n.controlCoordinates.initialScale,n.controlCoordinates.limitOffsetX=(n.controlCoordinates.imgWidth*n.controlCoordinates.targetScale-n.controlCoordinates.containerWidth)/2,n.controlCoordinates.limitOffsetY=(n.controlCoordinates.imgHeight*n.controlCoordinates.targetScale-n.controlCoordinates.containerHeight)/2,n.controlCoordinates.targetOffsetX=n.controlCoordinates.imgWidth*n.controlCoordinates.targetScale<=n.controlCoordinates.containerWidth?0:n.minMax(n.controlCoordinates.pointerOffsetX-(n.controlCoordinates.initialPointerOffsetX-n.controlCoordinates.initialOffsetX),-1*n.controlCoordinates.limitOffsetX,n.controlCoordinates.limitOffsetX),n.controlCoordinates.targetOffsetY=n.controlCoordinates.imgHeight*n.controlCoordinates.targetScale<=n.controlCoordinates.containerHeight?0:n.minMax(n.controlCoordinates.pointerOffsetY-(n.controlCoordinates.initialPointerOffsetY-n.controlCoordinates.initialOffsetY),-1*n.controlCoordinates.limitOffsetY,n.controlCoordinates.limitOffsetY),Math.abs(n.controlCoordinates.targetOffsetX)===Math.abs(n.controlCoordinates.limitOffsetX)&&(n.controlCoordinates.initialOffsetX=n.controlCoordinates.targetOffsetX,n.controlCoordinates.initialPointerOffsetX=n.controlCoordinates.pointerOffsetX),Math.abs(n.controlCoordinates.targetOffsetY)===Math.abs(n.controlCoordinates.limitOffsetY)&&(n.controlCoordinates.initialOffsetY=n.controlCoordinates.targetOffsetY,n.controlCoordinates.initialPointerOffsetY=n.controlCoordinates.pointerOffsetY),n.setZoomData(n.controlCoordinates.initialScale,n.controlCoordinates.targetOffsetX,n.controlCoordinates.targetOffsetY),n.zoomPanElement(n.controlCoordinates.targetOffsetX+"px",n.controlCoordinates.targetOffsetY+"px",n.controlCoordinates.targetScale))}if("mousemove"===t.type&&n.controlCoordinates.mousedown){if("touchmove"==t.type)return!0;if(t.preventDefault(),!1===n.controlCoordinates.capture)return!1;n.controlCoordinates.pointerOffsetX=t.clientX,n.controlCoordinates.pointerOffsetY=t.clientY,n.controlCoordinates.targetScale=n.controlCoordinates.initialScale,n.controlCoordinates.limitOffsetX=(n.controlCoordinates.imgWidth*n.controlCoordinates.targetScale-n.controlCoordinates.containerWidth)/2,n.controlCoordinates.limitOffsetY=(n.controlCoordinates.imgHeight*n.controlCoordinates.targetScale-n.controlCoordinates.containerHeight)/2,n.controlCoordinates.targetOffsetX=n.controlCoordinates.imgWidth*n.controlCoordinates.targetScale<=n.controlCoordinates.containerWidth?0:n.minMax(n.controlCoordinates.pointerOffsetX-(n.controlCoordinates.initialPointerOffsetX-n.controlCoordinates.initialOffsetX),-1*n.controlCoordinates.limitOffsetX,n.controlCoordinates.limitOffsetX),n.controlCoordinates.targetOffsetY=n.controlCoordinates.imgHeight*n.controlCoordinates.targetScale<=n.controlCoordinates.containerHeight?0:n.minMax(n.controlCoordinates.pointerOffsetY-(n.controlCoordinates.initialPointerOffsetY-n.controlCoordinates.initialOffsetY),-1*n.controlCoordinates.limitOffsetY,n.controlCoordinates.limitOffsetY),Math.abs(n.controlCoordinates.targetOffsetX)===Math.abs(n.controlCoordinates.limitOffsetX)&&(n.controlCoordinates.initialOffsetX=n.controlCoordinates.targetOffsetX,n.controlCoordinates.initialPointerOffsetX=n.controlCoordinates.pointerOffsetX),Math.abs(n.controlCoordinates.targetOffsetY)===Math.abs(n.controlCoordinates.limitOffsetY)&&(n.controlCoordinates.initialOffsetY=n.controlCoordinates.targetOffsetY,n.controlCoordinates.initialPointerOffsetY=n.controlCoordinates.pointerOffsetY),n.setZoomData(n.controlCoordinates.initialScale,n.controlCoordinates.targetOffsetX,n.controlCoordinates.targetOffsetY),n.zoomPanElement(n.controlCoordinates.targetOffsetX+"px",n.controlCoordinates.targetOffsetY+"px",n.controlCoordinates.targetScale)}n.controlCoordinates.zoomed||(n.controlCoordinates.swipeEnd=t.pageX||t.touches[0].pageX,n.controlCoordinates.swipeYEnd=t.pageY||t.touches[0].pageY,n.controlCoordinates.swipeDiff=n.controlCoordinates.swipeStart-n.controlCoordinates.swipeEnd,n.controlCoordinates.swipeYDiff=n.controlCoordinates.swipeYStart-n.controlCoordinates.swipeYEnd,n.options.animationSlide&&n.slide(0,-n.controlCoordinates.swipeDiff+"px"))}),this.addEventListener(this.domNodes.image,["touchend."+this.eventNamespace,"mouseup."+this.eventNamespace,"touchcancel."+this.eventNamespace,"mouseleave."+this.eventNamespace,"pointerup","pointercancel","MSPointerUp","MSPointerCancel"],function(t){n.isTouchDevice&&"touchend"===t.type&&(n.controlCoordinates.touchCount=t.touches.length,0===n.controlCoordinates.touchCount?(n.currentImage&&n.setZoomData(n.controlCoordinates.initialScale,n.controlCoordinates.targetOffsetX,n.controlCoordinates.targetOffsetY),1===n.controlCoordinates.initialScale&&(n.controlCoordinates.zoomed=!1,"none"===n.domNodes.caption.style.display&&n.fadeIn(n.domNodes.caption,n.options.fadeSpeed)),n.controlCoordinates.initialPinchDistance=null,n.controlCoordinates.capture=!1):1===n.controlCoordinates.touchCount?(n.controlCoordinates.initialPointerOffsetX=t.touches[0].clientX,n.controlCoordinates.initialPointerOffsetY=t.touches[0].clientY):1<n.controlCoordinates.touchCount&&(n.controlCoordinates.initialPinchDistance=null)),n.controlCoordinates.mousedown&&(t=!(n.controlCoordinates.mousedown=!1),n.options.loop||(0===n.currentImageIndex&&n.controlCoordinates.swipeDiff<0&&(t=!1),n.currentImageIndex>=n.relatedElements.length-1&&0<n.controlCoordinates.swipeDiff&&(t=!1)),Math.abs(n.controlCoordinates.swipeDiff)>n.options.swipeTolerance&&t?n.loadImage(0<n.controlCoordinates.swipeDiff?1:-1):n.options.animationSlide&&n.slide(n.options.animationSpeed/1e3,"0px"),n.options.swipeClose&&50<Math.abs(n.controlCoordinates.swipeYDiff)&&Math.abs(n.controlCoordinates.swipeDiff)<n.options.swipeTolerance&&n.close())}),this.addEventListener(this.domNodes.image,["dblclick"],function(t){if(!n.isTouchDevice)return n.controlCoordinates.initialPointerOffsetX=t.clientX,n.controlCoordinates.initialPointerOffsetY=t.clientY,n.controlCoordinates.containerHeight=n.getDimensions(n.domNodes.image).height,n.controlCoordinates.containerWidth=n.getDimensions(n.domNodes.image).width,n.controlCoordinates.imgHeight=n.getDimensions(n.currentImage).height,n.controlCoordinates.imgWidth=n.getDimensions(n.currentImage).width,n.controlCoordinates.containerOffsetX=n.domNodes.image.offsetLeft,n.controlCoordinates.containerOffsetY=n.domNodes.image.offsetTop,n.currentImage.classList.add("sl-transition"),n.controlCoordinates.zoomed?(n.controlCoordinates.initialScale=1,n.setZoomData(n.controlCoordinates.initialScale,0,0),n.zoomPanElement("0px","0px",n.controlCoordinates.initialScale),n.controlCoordinates.zoomed=!1,"none"===n.domNodes.caption.style.display&&n.fadeIn(n.domNodes.caption,n.options.fadeSpeed)):(n.controlCoordinates.initialScale=n.options.doubleTapZoom,n.setZoomData(n.controlCoordinates.initialScale,0,0),n.zoomPanElement("0px","0px",n.controlCoordinates.initialScale),(!n.domNodes.caption.style.opacity||0<n.domNodes.caption.style.opacity)&&"none"!==n.domNodes.caption.style.display&&n.fadeOut(n.domNodes.caption,n.options.fadeSpeed),n.controlCoordinates.zoomed=!0),setTimeout(function(){n.currentImage&&(n.currentImage.classList.remove("sl-transition"),n.currentImage.style[n.transitionPrefix+"transform-origin"]=null)},200),!(n.controlCoordinates.capture=!0)})}},{key:"getDimensions",value:function(t){var e=window.getComputedStyle(t),o=t.offsetHeight,t=t.offsetWidth,n=parseFloat(e.borderTopWidth);return{height:o-parseFloat(e.borderBottomWidth)-n-parseFloat(e.paddingTop)-parseFloat(e.paddingBottom),width:t-parseFloat(e.borderLeftWidth)-parseFloat(e.borderRightWidth)-parseFloat(e.paddingLeft)-parseFloat(e.paddingRight)}}},{key:"updateHash",value:function(){var t="pid="+(this.currentImageIndex+1),e=window.location.href.split("#")[0]+"#"+t;this.hashReseted=!1,this.pushStateSupport?window.history[this.historyHasChanges?"replaceState":"pushState"]("",document.title,e):this.historyHasChanges?window.location.replace(e):window.location.hash=t,this.historyHasChanges||(this.urlChangedOnce=!0),this.historyHasChanges=!0}},{key:"resetHash",value:function(){this.hashReseted=!0,this.urlChangedOnce?history.back():this.pushStateSupport?history.pushState("",document.title,window.location.pathname+window.location.search):window.location.hash="",clearTimeout(this.historyUpdateTimeout)}},{key:"updateURL",value:function(){clearTimeout(this.historyUpdateTimeout),this.historyHasChanges?this.historyUpdateTimeout=setTimeout(this.updateHash.bind(this),800):this.updateHash()}},{key:"setCaption",value:function(t,e,o){var n=this;this.options.captions&&t&&""!==t&&void 0!==t&&(o=null==(o=null!=o?o:this.options.captionHTML)||o?"innerHTML":"innerText",this.hide(this.domNodes.caption),this.domNodes.caption.style.width=e+"px",this.domNodes.caption[o]=t,this.domNodes.image.appendChild(this.domNodes.caption),setTimeout(function(){n.fadeIn(n.domNodes.caption,n.options.fadeSpeed)},this.options.captionDelay))}},{key:"slide",value:function(t,e){if(!this.transitionCapable)return this.domNodes.image.style.left=e;this.domNodes.image.style[this.transitionPrefix+"transform"]="translateX("+e+")",this.domNodes.image.style[this.transitionPrefix+"transition"]=this.transitionPrefix+"transform "+t+"s linear"}},{key:"getRelated",value:function(e){var t=e&&!1!==e&&"nofollow"!==e?Array.from(this.elements).filter(function(t){return t.getAttribute("rel")===e}):this.elements;return t}},{key:"openImage",value:function(t){var e=this,o=(t.dispatchEvent(new Event("show."+this.eventNamespace)),this.globalScrollbarWidth=this.getScrollbarWidth(),this.options.disableScroll&&(this.toggleScrollbar("hide"),this.globalScrollbarWidth=0),this.options.htmlClass&&""!==this.options.htmlClass&&document.querySelector("html").classList.add(this.options.htmlClass),document.body.appendChild(this.domNodes.wrapper),this.domNodes.wrapper.appendChild(this.domNodes.image),this.options.overlay&&document.body.appendChild(this.domNodes.overlay),this.relatedElements=this.getRelated(t.rel),this.options.showCounter&&(1==this.relatedElements.length&&this.domNodes.wrapper.contains(this.domNodes.counter)?this.domNodes.wrapper.removeChild(this.domNodes.counter):1<this.relatedElements.length&&!this.domNodes.wrapper.contains(this.domNodes.counter)&&this.domNodes.wrapper.appendChild(this.domNodes.counter)),this.options.download&&this.domNodes.download&&this.domNodes.wrapper.appendChild(this.domNodes.download),this.isAnimating=!0,this.currentImageIndex=this.relatedElements.indexOf(t),t.getAttribute(this.options.sourceAttr));this.currentImage=document.createElement("img"),this.currentImage.style.display="none",this.currentImage.setAttribute("src",o),this.currentImage.dataset.scale=1,this.currentImage.dataset.translateX=0,this.currentImage.dataset.translateY=0,-1===this.loadedImages.indexOf(o)&&this.loadedImages.push(o),this.domNodes.image.innerHTML="",this.domNodes.image.setAttribute("style",""),this.domNodes.image.appendChild(this.currentImage),this.fadeIn(this.domNodes.overlay,this.options.fadeSpeed),this.fadeIn([this.domNodes.counter,this.domNodes.navigation,this.domNodes.closeButton,this.domNodes.download],this.options.fadeSpeed),this.show(this.domNodes.spinner),this.domNodes.counter.querySelector(".sl-current").innerHTML=this.currentImageIndex+1,this.domNodes.counter.querySelector(".sl-total").innerHTML=this.relatedElements.length,this.adjustImage(),this.options.preloading&&this.preload(),setTimeout(function(){t.dispatchEvent(new Event("shown."+e.eventNamespace))},this.options.animationSpeed)}},{key:"forceFocus",value:function(){var e=this;this.removeEventListener(document,"focusin."+this.eventNamespace),this.addEventListener(document,"focusin."+this.eventNamespace,function(t){document===t.target||e.domNodes.wrapper===t.target||e.domNodes.wrapper.contains(t.target)||e.domNodes.wrapper.focus()})}},{key:"addEventListener",value:function(t,e,o,n){t=this.wrap(t),e=this.wrap(e);var i,s=f(t);try{for(s.s();!(i=s.n()).done;){var a,r=i.value,l=(r.namespaces||(r.namespaces={}),f(e));try{for(l.s();!(a=l.n()).done;){var d=a.value,c=n||!1;0<=["touchstart","touchmove","mousewheel","DOMMouseScroll"].indexOf(d.split(".")[0])&&this.isPassiveEventsSupported&&("object"===h(c)?c.passive=!0:c={passive:!0}),r.namespaces[d]=o,r.addEventListener(d.split(".")[0],o,c)}}catch(t){l.e(t)}finally{l.f()}}}catch(t){s.e(t)}finally{s.f()}}},{key:"removeEventListener",value:function(t,e){t=this.wrap(t),e=this.wrap(e);var o,n=f(t);try{for(n.s();!(o=n.n()).done;){var i,s=o.value,a=f(e);try{for(a.s();!(i=a.n()).done;){var r=i.value;s.namespaces&&s.namespaces[r]&&(s.removeEventListener(r.split(".")[0],s.namespaces[r]),delete s.namespaces[r])}}catch(t){a.e(t)}finally{a.f()}}}catch(t){n.e(t)}finally{n.f()}}},{key:"fadeOut",value:function(r,t,l){var e,d=this,o=f(r=this.wrap(r));try{for(o.s();!(e=o.n()).done;){var n=e.value;n.style.opacity=parseFloat(n)||window.getComputedStyle(n).getPropertyValue("opacity")}}catch(t){o.e(t)}finally{o.f()}this.isFadeIn=!1;var c=16.66666/(t||this.options.fadeSpeed);(function t(){var e=parseFloat(r[0].style.opacity);if((e-=c)<0){var o,n=f(r);try{for(n.s();!(o=n.n()).done;){var i=o.value;i.style.display="none",i.style.opacity=1}}catch(t){n.e(t)}finally{n.f()}l&&l.call(d,r)}else{var s,a=f(r);try{for(a.s();!(s=a.n()).done;)s.value.style.opacity=e}catch(t){a.e(t)}finally{a.f()}requestAnimationFrame(t)}})()}},{key:"fadeIn",value:function(l,t,d,e){var o,c=this,n=f(l=this.wrap(l));try{for(n.s();!(o=n.n()).done;){var i=o.value;i&&(i.style.opacity=0,i.style.display=e||"block")}}catch(t){n.e(t)}finally{n.f()}this.isFadeIn=!0;var h=parseFloat(l[0].dataset.opacityTarget||1),m=16.66666*h/(t||this.options.fadeSpeed);(function t(){var e=parseFloat(l[0].style.opacity);if((e+=m)>h){var o,n=f(l);try{for(n.s();!(o=n.n()).done;){var i=o.value;i&&(i.style.opacity=h)}}catch(t){n.e(t)}finally{n.f()}d&&d.call(c,l)}else{var s,a=f(l);try{for(a.s();!(s=a.n()).done;){var r=s.value;r&&(r.style.opacity=e)}}catch(t){a.e(t)}finally{a.f()}c.isFadeIn&&requestAnimationFrame(t)}})()}},{key:"hide",value:function(t){var e,o=f(t=this.wrap(t));try{for(o.s();!(e=o.n()).done;){var n=e.value;"none"!=n.style.display&&(n.dataset.initialDisplay=n.style.display),n.style.display="none"}}catch(t){o.e(t)}finally{o.f()}}},{key:"show",value:function(t,e){var o,n=f(t=this.wrap(t));try{for(n.s();!(o=n.n()).done;){var i=o.value;i.style.display=i.dataset.initialDisplay||e||"block"}}catch(t){n.e(t)}finally{n.f()}}},{key:"wrap",value:function(t){return"function"==typeof t[Symbol.iterator]&&"string"!=typeof t?t:[t]}},{key:"on",value:function(t,e){t=this.wrap(t);var o,n=f(this.elements);try{for(n.s();!(o=n.n()).done;){var i,s=o.value,a=(s.fullyNamespacedEvents||(s.fullyNamespacedEvents={}),f(t));try{for(a.s();!(i=a.n()).done;){var r=i.value;s.fullyNamespacedEvents[r]=e,s.addEventListener(r,e)}}catch(t){a.e(t)}finally{a.f()}}}catch(t){n.e(t)}finally{n.f()}return this}},{key:"off",value:function(t){t=this.wrap(t);var e,o=f(this.elements);try{for(o.s();!(e=o.n()).done;){var n,i=e.value,s=f(t);try{for(s.s();!(n=s.n()).done;){var a=n.value;void 0!==i.fullyNamespacedEvents&&a in i.fullyNamespacedEvents&&i.removeEventListener(a,i.fullyNamespacedEvents[a])}}catch(t){s.e(t)}finally{s.f()}}}catch(t){o.e(t)}finally{o.f()}return this}},{key:"open",value:function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0;t=t||this.elements[0],"undefined"!=typeof jQuery&&t instanceof jQuery&&(t=t.get(0)),0<e&&(t=this.elements[e]),this.initialImageIndex=this.elements.indexOf(t),-1<this.initialImageIndex&&this.openImage(t)}},{key:"openPosition",value:function(t){var e=this.elements[t];this.open(e,t)}},{key:"next",value:function(){this.loadImage(1)}},{key:"prev",value:function(){this.loadImage(-1)}},{key:"getLighboxData",value:function(){return{currentImageIndex:this.currentImageIndex,currentImage:this.currentImage,globalScrollbarWidth:this.globalScrollbarWidth}}},{key:"destroy",value:function(){this.off(["close."+this.eventNamespace,"closed."+this.eventNamespace,"nextImageLoaded."+this.eventNamespace,"prevImageLoaded."+this.eventNamespace,"change."+this.eventNamespace,"nextDone."+this.eventNamespace,"prevDone."+this.eventNamespace,"error."+this.eventNamespace,"changed."+this.eventNamespace,"next."+this.eventNamespace,"prev."+this.eventNamespace,"show."+this.eventNamespace,"shown."+this.eventNamespace]),this.removeEventListener(this.elements,"click."+this.eventNamespace),this.removeEventListener(document,"focusin."+this.eventNamespace),this.removeEventListener(document.body,"contextmenu."+this.eventNamespace),this.removeEventListener(document.body,"keyup."+this.eventNamespace),this.removeEventListener(this.domNodes.navigation.getElementsByTagName("button"),"click."+this.eventNamespace),this.removeEventListener(this.domNodes.closeButton,"click."+this.eventNamespace),this.removeEventListener(window,"resize."+this.eventNamespace),this.removeEventListener(window,"hashchange."+this.eventNamespace),this.close(),this.isOpen&&(document.body.removeChild(this.domNodes.wrapper),document.body.removeChild(this.domNodes.overlay)),this.elements=null}},{key:"refresh",value:function(){var t,e;if(this.initialSelector)return t=this.options,e=this.initialSelector,this.destroy(),this.constructor(e,t),this;throw"refreshing only works when you initialize using a selector!"}}])&&s(t.prototype,e),o&&s(t,o),Object.defineProperty(t,"prototype",{writable:!1}),i}();o.default=t,e.SimpleLightbox=t}.call(this)}.call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1]);

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
( function() {
	var isIe = /(trident|msie)/i.test( navigator.userAgent );

	if ( isIe && document.getElementById && window.addEventListener ) {
		window.addEventListener( 'hashchange', function() {
			var id = location.hash.substring( 1 ),
				element;

			if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
				return;
			}

			element = document.getElementById( id );

			if ( element ) {
				if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
					element.tabIndex = -1;
				}

				element.focus();
			}
		}, false );
	}
} )();


function r(n,t){for(var i=0;i<t.length;i++){var r=t[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(n,r.key,r)}}function Jt(n,t,i){t&&r(n.prototype,t),i&&r(n,i),Object.defineProperty(n,"prototype",{writable:!1})}
/*!
 * Splide.js
 * Version  : 4.1.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
var n,t;n=this,t=function(){"use strict";var v="(prefers-reduced-motion: reduce)",G=4,rn=5,r={CREATED:1,MOUNTED:2,IDLE:3,MOVING:G,SCROLLING:rn,DRAGGING:6,DESTROYED:7};function D(n){n.length=0}function o(n,t,i){return Array.prototype.slice.call(n,t,i)}function R(n){return n.bind.apply(n,[null].concat(o(arguments,1)))}function on(){}var p=setTimeout;function h(n){return requestAnimationFrame(n)}function u(n,t){return typeof t===n}function un(n){return!c(n)&&u("object",n)}var e=Array.isArray,x=R(u,"function"),C=R(u,"string"),en=R(u,"undefined");function c(n){return null===n}function m(n){try{return n instanceof(n.ownerDocument.defaultView||window).HTMLElement}catch(n){return!1}}function y(n){return e(n)?n:[n]}function g(n,t){y(n).forEach(t)}function b(n,t){return-1<n.indexOf(t)}function k(n,t){return n.push.apply(n,y(t)),n}function A(t,n,i){t&&g(n,function(n){n&&t.classList[i?"add":"remove"](n)})}function M(n,t){A(n,C(t)?t.split(" "):t,!0)}function L(n,t){g(t,n.appendChild.bind(n))}function O(n,i){g(n,function(n){var t=(i||n).parentNode;t&&t.insertBefore(n,i)})}function cn(n,t){return m(n)&&(n.msMatchesSelector||n.matches).call(n,t)}function S(n,t){n=n?o(n.children):[];return t?n.filter(function(n){return cn(n,t)}):n}function fn(n,t){return t?S(n,t)[0]:n.firstElementChild}var E=Object.keys;function w(t,i,n){t&&(n?E(t).reverse():E(t)).forEach(function(n){"__proto__"!==n&&i(t[n],n)})}function an(r){return o(arguments,1).forEach(function(i){w(i,function(n,t){r[t]=i[t]})}),r}function d(i){return o(arguments,1).forEach(function(n){w(n,function(n,t){e(n)?i[t]=n.slice():un(n)?i[t]=d({},un(i[t])?i[t]:{},n):i[t]=n})}),i}function sn(t,n){g(n||E(t),function(n){delete t[n]})}function P(n,i){g(n,function(t){g(i,function(n){t&&t.removeAttribute(n)})})}function I(i,t,r){un(t)?w(t,function(n,t){I(i,t,n)}):g(i,function(n){c(r)||""===r?P(n,t):n.setAttribute(t,String(r))})}function j(n,t,i){n=document.createElement(n);return t&&(C(t)?M:I)(n,t),i&&L(i,n),n}function _(n,t,i){if(en(i))return getComputedStyle(n)[t];c(i)||(n.style[t]=""+i)}function ln(n,t){_(n,"display",t)}function dn(n){n.setActive&&n.setActive()||n.focus({preventScroll:!0})}function z(n,t){return n.getAttribute(t)}function vn(n,t){return n&&n.classList.contains(t)}function N(n){return n.getBoundingClientRect()}function T(n){g(n,function(n){n&&n.parentNode&&n.parentNode.removeChild(n)})}function hn(n){return fn((new DOMParser).parseFromString(n,"text/html").body)}function F(n,t){n.preventDefault(),t&&(n.stopPropagation(),n.stopImmediatePropagation())}function pn(n,t){return n&&n.querySelector(t)}function gn(n,t){return t?o(n.querySelectorAll(t)):[]}function X(n,t){A(n,t,!1)}function mn(n){return n.timeStamp}function W(n){return C(n)?n:n?n+"px":""}var yn="splide",f="data-"+yn;function bn(n,t){if(!n)throw new Error("["+yn+"] "+(t||""))}var Y=Math.min,wn=Math.max,xn=Math.floor,kn=Math.ceil,U=Math.abs;function Sn(n,t,i){return U(n-t)<i}function En(n,t,i,r){var o=Y(t,i),t=wn(t,i);return r?o<n&&n<t:o<=n&&n<=t}function q(n,t,i){var r=Y(t,i),t=wn(t,i);return Y(wn(r,n),t)}function Ln(n){return(0<n)-(n<0)}function On(t,n){return g(n,function(n){t=t.replace("%s",""+n)}),t}function An(n){return n<10?"0"+n:""+n}var _n={};function zn(){var c=[];function i(n,i,r){g(n,function(t){t&&g(i,function(n){n.split(" ").forEach(function(n){n=n.split(".");r(t,n[0],n[1])})})})}return{bind:function(n,t,u,e){i(n,t,function(n,t,i){var r="addEventListener"in n,o=r?n.removeEventListener.bind(n,t,u,e):n.removeListener.bind(n,u);r?n.addEventListener(t,u,e):n.addListener(u),c.push([n,t,i,u,o])})},unbind:function(n,t,o){i(n,t,function(t,i,r){c=c.filter(function(n){return!!(n[0]!==t||n[1]!==i||n[2]!==r||o&&n[3]!==o)||(n[4](),!1)})})},dispatch:function(n,t,i){var r;return"function"==typeof CustomEvent?r=new CustomEvent(t,{bubbles:!0,detail:i}):(r=document.createEvent("CustomEvent")).initCustomEvent(t,!0,!1,i),n.dispatchEvent(r),r},destroy:function(){c.forEach(function(n){n[4]()}),D(c)}}}var B="mounted",H="move",Dn="moved",Mn="click",Pn="active",In="inactive",Rn="visible",Cn="hidden",J="refresh",K="updated",jn="resize",Nn="resized",Tn="scroll",V="scrolled",a="destroy",Gn="navigation:mounted",Fn="autoplay:play",Xn="autoplay:pause",Wn="lazyload:loaded",Yn="sk",Un="sh";function Q(n){var i=n?n.event.bus:document.createDocumentFragment(),r=zn();return n&&n.event.on(a,r.destroy),an(r,{bus:i,on:function(n,t){r.bind(i,y(n).join(" "),function(n){t.apply(t,e(n.detail)?n.detail:[])})},off:R(r.unbind,i),emit:function(n){r.dispatch(i,n,o(arguments,1))}})}function qn(t,n,i,r){var o,u,e=Date.now,c=0,f=!0,a=0;function s(){if(!f){if(c=t?Y((e()-o)/t,1):1,i&&i(c),1<=c&&(n(),o=e(),r&&++a>=r))return l();u=h(s)}}function l(){f=!0}function d(){u&&cancelAnimationFrame(u),f=!(u=c=0)}return{start:function(n){n||d(),o=e()-(n?c*t:0),f=!1,u=h(s)},rewind:function(){o=e(),c=0,i&&i(c)},pause:l,cancel:d,set:function(n){t=n},isPaused:function(){return f}}}function s(n){var t=n;return{set:function(n){t=n},is:function(n){return b(y(n),t)}}}var n="Arrow",Bn=n+"Left",Hn=n+"Right",t=n+"Up",n=n+"Down",Jn="ttb",l={width:["height"],left:["top","right"],right:["bottom","left"],x:["y"],X:["Y"],Y:["X"],ArrowLeft:[t,Hn],ArrowRight:[n,Bn]};var Z="role",$="tabindex",i="aria-",Kn=i+"controls",Vn=i+"current",Qn=i+"selected",nn=i+"label",Zn=i+"labelledby",$n=i+"hidden",nt=i+"orientation",tt=i+"roledescription",it=i+"live",rt=i+"busy",ot=i+"atomic",ut=[Z,$,"disabled",Kn,Vn,nn,Zn,$n,nt,tt],i=yn+"__",et=yn,ct=i+"track",ft=i+"list",at=i+"slide",st=at+"--clone",lt=at+"__container",dt=i+"arrows",vt=i+"arrow",ht=vt+"--prev",pt=vt+"--next",gt=i+"pagination",mt=gt+"__page",yt=i+"progress"+"__bar",bt=i+"toggle",wt=i+"sr",tn="is-active",xt="is-prev",kt="is-next",St="is-visible",Et="is-loading",Lt="is-focus-in",Ot="is-overflow",At=[tn,St,xt,kt,Et,Lt,Ot];var _t="touchstart mousedown",zt="touchmove mousemove",Dt="touchend touchcancel mouseup click";var Mt="slide",Pt="loop",It="fade";function Rt(o,r,t,u){var e,n=Q(o),i=n.on,c=n.emit,f=n.bind,a=o.Components,s=o.root,l=o.options,d=l.isNavigation,v=l.updateOnMove,h=l.i18n,p=l.pagination,g=l.slideFocus,m=a.Direction.resolve,y=z(u,"style"),b=z(u,nn),w=-1<t,x=fn(u,"."+lt);function k(){var n=o.splides.map(function(n){n=n.splide.Components.Slides.getAt(r);return n?n.slide.id:""}).join(" ");I(u,nn,On(h.slideX,(w?t:r)+1)),I(u,Kn,n),I(u,Z,g?"button":""),g&&P(u,tt)}function S(){e||E()}function E(){var n,t,i;e||(n=o.index,(i=L())!==vn(u,tn)&&(A(u,tn,i),I(u,Vn,d&&i||""),c(i?Pn:In,O)),i=function(){if(o.is(It))return L();var n=N(a.Elements.track),t=N(u),i=m("left",!0),r=m("right",!0);return xn(n[i])<=kn(t[i])&&xn(t[r])<=kn(n[r])}(),t=!i&&(!L()||w),o.state.is([G,rn])||I(u,$n,t||""),I(gn(u,l.focusableNodes||""),$,t?-1:""),g&&I(u,$,t?-1:0),i!==vn(u,St)&&(A(u,St,i),c(i?Rn:Cn,O)),i||document.activeElement!==u||(t=a.Slides.getAt(o.index))&&dn(t.slide),A(u,xt,r===n-1),A(u,kt,r===n+1))}function L(){var n=o.index;return n===r||l.cloneStatus&&n===t}var O={index:r,slideIndex:t,slide:u,container:x,isClone:w,mount:function(){w||(u.id=s.id+"-slide"+An(r+1),I(u,Z,p?"tabpanel":"group"),I(u,tt,h.slide),I(u,nn,b||On(h.slideLabel,[r+1,o.length]))),f(u,"click",R(c,Mn,O)),f(u,"keydown",R(c,Yn,O)),i([Dn,Un,V],E),i(Gn,k),v&&i(H,S)},destroy:function(){e=!0,n.destroy(),X(u,At),P(u,ut),I(u,"style",y),I(u,nn,b||"")},update:E,style:function(n,t,i){_(i&&x||u,n,t)},isWithin:function(n,t){return n=U(n-r),(n=w||!l.rewind&&!o.is(Pt)?n:Y(n,o.length-n))<=t}};return O}var Ct=f+"-interval";var jt={passive:!1,capture:!0};var Nt={Spacebar:" ",Right:Hn,Left:Bn,Up:t,Down:n};function Tt(n){return n=C(n)?n:n.key,Nt[n]||n}var Gt="keydown";var Ft=f+"-lazy",Xt=Ft+"-srcset",Wt="["+Ft+"], ["+Xt+"]";var Yt=[" ","Enter"];var Ut=Object.freeze({__proto__:null,Media:function(r,n,o){var u=r.state,t=o.breakpoints||{},e=o.reducedMotion||{},i=zn(),c=[];function f(n){n&&i.destroy()}function a(n,t){t=matchMedia(t);i.bind(t,"change",s),c.push([n,t])}function s(){var n=u.is(7),t=o.direction,i=c.reduce(function(n,t){return d(n,t[1].matches?t[0]:{})},{});sn(o),l(i),o.destroy?r.destroy("completely"===o.destroy):n?(f(!0),r.mount()):t!==o.direction&&r.refresh()}function l(n,t,i){d(o,n),t&&d(Object.getPrototypeOf(o),n),!i&&u.is(1)||r.emit(K,o)}return{setup:function(){var i="min"===o.mediaQuery;E(t).sort(function(n,t){return i?+n-+t:+t-+n}).forEach(function(n){a(t[n],"("+(i?"min":"max")+"-width:"+n+"px)")}),a(e,v),s()},destroy:f,reduce:function(n){matchMedia(v).matches&&(n?d(o,e):sn(o,E(e)))},set:l}},Direction:function(n,t,o){return{resolve:function(n,t,i){var r="rtl"!==(i=i||o.direction)||t?i===Jn?0:-1:1;return l[n]&&l[n][r]||n.replace(/width|left|right/i,function(n,t){n=l[n.toLowerCase()][r]||n;return 0<t?n.charAt(0).toUpperCase()+n.slice(1):n})},orient:function(n){return n*("rtl"===o.direction?1:-1)}}},Elements:function(n,t,i){var r,o,u,e=Q(n),c=e.on,f=e.bind,a=n.root,s=i.i18n,l={},d=[],v=[],h=[];function p(){r=y("."+ct),o=fn(r,"."+ft),bn(r&&o,"A track/list element is missing."),k(d,S(o,"."+at+":not(."+st+")")),w({arrows:dt,pagination:gt,prev:ht,next:pt,bar:yt,toggle:bt},function(n,t){l[t]=y("."+n)}),an(l,{root:a,track:r,list:o,slides:d});var n=a.id||function(n){return""+n+An(_n[n]=(_n[n]||0)+1)}(yn),t=i.role;a.id=n,r.id=r.id||n+"-track",o.id=o.id||n+"-list",!z(a,Z)&&"SECTION"!==a.tagName&&t&&I(a,Z,t),I(a,tt,s.carousel),I(o,Z,"presentation"),m()}function g(n){var t=ut.concat("style");D(d),X(a,v),X(r,h),P([r,o],t),P(a,n?t:["style",tt])}function m(){X(a,v),X(r,h),v=b(et),h=b(ct),M(a,v),M(r,h),I(a,nn,i.label),I(a,Zn,i.labelledby)}function y(n){n=pn(a,n);return n&&function(n,t){if(x(n.closest))return n.closest(t);for(var i=n;i&&1===i.nodeType&&!cn(i,t);)i=i.parentElement;return i}(n,"."+et)===a?n:void 0}function b(n){return[n+"--"+i.type,n+"--"+i.direction,i.drag&&n+"--draggable",i.isNavigation&&n+"--nav",n===et&&tn]}return an(l,{setup:p,mount:function(){c(J,g),c(J,p),c(K,m),f(document,_t+" keydown",function(n){u="keydown"===n.type},{capture:!0}),f(a,"focusin",function(){A(a,Lt,!!u)})},destroy:g})},Slides:function(r,o,u){var n=Q(r),t=n.on,e=n.emit,c=n.bind,f=(n=o.Elements).slides,a=n.list,s=[];function i(){f.forEach(function(n,t){d(n,t,-1)})}function l(){h(function(n){n.destroy()}),D(s)}function d(n,t,i){t=Rt(r,t,i,n);t.mount(),s.push(t),s.sort(function(n,t){return n.index-t.index})}function v(n){return n?p(function(n){return!n.isClone}):s}function h(n,t){v(t).forEach(n)}function p(t){return s.filter(x(t)?t:function(n){return C(t)?cn(n.slide,t):b(y(t),n.index)})}return{mount:function(){i(),t(J,l),t(J,i)},destroy:l,update:function(){h(function(n){n.update()})},register:d,get:v,getIn:function(n){var t=o.Controller,i=t.toIndex(n),r=t.hasFocus()?1:u.perPage;return p(function(n){return En(n.index,i,i+r-1)})},getAt:function(n){return p(n)[0]},add:function(n,o){g(n,function(n){var t,i,r;m(n=C(n)?hn(n):n)&&((t=f[o])?O(n,t):L(a,n),M(n,u.classes.slide),t=n,i=R(e,jn),t=gn(t,"img"),(r=t.length)?t.forEach(function(n){c(n,"load error",function(){--r||i()})}):i())}),e(J)},remove:function(n){T(p(n).map(function(n){return n.slide})),e(J)},forEach:h,filter:p,style:function(t,i,r){h(function(n){n.style(t,i,r)})},getLength:function(n){return(n?f:s).length},isEnough:function(){return s.length>u.perPage}}},Layout:function(t,n,i){var r,o,u,e=(a=Q(t)).on,c=a.bind,f=a.emit,a=n.Slides,s=n.Direction.resolve,l=(n=n.Elements).root,d=n.track,v=n.list,h=a.getAt,p=a.style;function g(){r=i.direction===Jn,_(l,"maxWidth",W(i.width)),_(d,s("paddingLeft"),y(!1)),_(d,s("paddingRight"),y(!0)),m(!0)}function m(n){var t=N(l);!n&&o.width===t.width&&o.height===t.height||(_(d,"height",function(){var n="";r&&(bn(n=b(),"height or heightRatio is missing."),n="calc("+n+" - "+y(!1)+" - "+y(!0)+")");return n}()),p(s("marginRight"),W(i.gap)),p("width",i.autoWidth?null:W(i.fixedWidth)||(r?"":w())),p("height",W(i.fixedHeight)||(r?i.autoHeight?null:w():b()),!0),o=t,f(Nn),u!==(u=O())&&(A(l,Ot,u),f("overflow",u)))}function y(n){var t=i.padding,n=s(n?"right":"left");return t&&W(t[n]||(un(t)?0:t))||"0px"}function b(){return W(i.height||N(v).width*i.heightRatio)}function w(){var n=W(i.gap);return"calc((100%"+(n&&" + "+n)+")/"+(i.perPage||1)+(n&&" - "+n)+")"}function x(){return N(v)[s("width")]}function k(n,t){n=h(n||0);return n?N(n.slide)[s("width")]+(t?0:L()):0}function S(n,t){var i,n=h(n);return n?(n=N(n.slide)[s("right")],i=N(v)[s("left")],U(n-i)+(t?0:L())):0}function E(n){return S(t.length-1)-S(0)+k(0,n)}function L(){var n=h(0);return n&&parseFloat(_(n.slide,s("marginRight")))||0}function O(){return t.is(It)||E(!0)>x()}return{mount:function(){var n,t,i;g(),c(window,"resize load",(n=R(f,jn),i=qn(t||0,n,null,1),function(){i.isPaused()&&i.start()})),e([K,J],g),e(jn,m)},resize:m,listSize:x,slideSize:k,sliderSize:E,totalSize:S,getPadding:function(n){return parseFloat(_(d,s("padding"+(n?"Right":"Left"))))||0},isOverflow:O}},Clones:function(c,i,f){var t,r=Q(c),n=r.on,a=i.Elements,s=i.Slides,o=i.Direction.resolve,l=[];function u(){if(n(J,d),n([K,jn],v),t=h()){var o=t,u=s.get().slice(),e=u.length;if(e){for(;u.length<o;)k(u,u);k(u.slice(-o),u.slice(0,o)).forEach(function(n,t){var i=t<o,r=function(n,t){n=n.cloneNode(!0);return M(n,f.classes.clone),n.id=c.root.id+"-clone"+An(t+1),n}(n.slide,t);i?O(r,u[0].slide):L(a.list,r),k(l,r),s.register(r,t-o+(i?0:e),n.index)})}i.Layout.resize(!0)}}function d(){e(),u()}function e(){T(l),D(l),r.destroy()}function v(){var n=h();t!==n&&(t<n||!n)&&r.emit(J)}function h(){var n,t=f.clones;return c.is(Pt)?en(t)&&(t=(n=f[o("fixedWidth")]&&i.Layout.slideSize(0))&&kn(N(a.track)[o("width")]/n)||f[o("autoWidth")]&&c.length||2*f.perPage):t=0,t}return{mount:u,destroy:e}},Move:function(r,c,o){var e,n=Q(r),t=n.on,f=n.emit,a=r.state.set,u=(n=c.Layout).slideSize,i=n.getPadding,s=n.totalSize,l=n.listSize,d=n.sliderSize,v=(n=c.Direction).resolve,h=n.orient,p=(n=c.Elements).list,g=n.track;function m(){c.Controller.isBusy()||(c.Scroll.cancel(),y(r.index),c.Slides.update())}function y(n){b(S(n,!0))}function b(n,t){r.is(It)||(t=t?n:function(n){{var t,i;r.is(Pt)&&(t=k(n),i=t>c.Controller.getEnd(),(t<0||i)&&(n=w(n,i)))}return n}(n),_(p,"transform","translate"+v("X")+"("+t+"px)"),n!==t&&f(Un))}function w(n,t){var i=n-L(t),r=d();return n-=h(r*(kn(U(i)/r)||1))*(t?1:-1)}function x(){b(E(),!0),e.cancel()}function k(n){for(var t=c.Slides.get(),i=0,r=1/0,o=0;o<t.length;o++){var u=t[o].index,e=U(S(u,!0)-n);if(!(e<=r))break;r=e,i=u}return i}function S(n,t){var i=h(s(n-1)-(n=n,"center"===(i=o.focus)?(l()-u(n,!0))/2:+i*u(n)||0));return t?(n=i,n=o.trimSpace&&r.is(Mt)?q(n,0,h(d(!0)-l())):n):i}function E(){var n=v("left");return N(p)[n]-N(g)[n]+h(i(!1))}function L(n){return S(n?c.Controller.getEnd():0,!!o.trimSpace)}return{mount:function(){e=c.Transition,t([B,Nn,K,J],m)},move:function(n,t,i,r){var o,u;n!==t&&(o=i<n,u=h(w(E(),o)),o?0<=u:u<=p[v("scrollWidth")]-N(g)[v("width")])&&(x(),b(w(E(),i<n),!0)),a(G),f(H,t,i,n),e.start(t,function(){a(3),f(Dn,t,i,n),r&&r()})},jump:y,translate:b,shift:w,cancel:x,toIndex:k,toPosition:S,getPosition:E,getLimit:L,exceededLimit:function(n,t){t=en(t)?E():t;var i=!0!==n&&h(t)<h(L(!1)),n=!1!==n&&h(t)>h(L(!0));return i||n},reposition:m}},Controller:function(o,u,e){var c,f,a,s,n=Q(o),t=n.on,i=n.emit,l=u.Move,d=l.getPosition,r=l.getLimit,v=l.toPosition,h=(n=u.Slides).isEnough,p=n.getLength,g=e.omitEnd,m=o.is(Pt),y=o.is(Mt),b=R(L,!1),w=R(L,!0),x=e.start||0,k=x;function S(){f=p(!0),a=e.perMove,s=e.perPage,c=_();var n=q(x,0,g?c:f-1);n!==x&&(x=n,l.reposition())}function E(){c!==_()&&i("ei")}function L(n,t){var i=a||(P()?1:s),i=O(x+i*(n?-1:1),x,!(a||P()));return-1===i&&y&&!Sn(d(),r(!n),1)?n?0:c:t?i:A(i)}function O(n,t,i){var r;return h()||P()?((r=function(n){if(y&&"move"===e.trimSpace&&n!==x)for(var t=d();t===v(n,!0)&&En(n,0,o.length-1,!e.rewind);)n<x?--n:++n;return n}(n))!==n&&(t=n,n=r,i=!1),n<0||c<n?n=a||!En(0,n,t,!0)&&!En(c,t,n,!0)?m?i?n<0?-(f%s||s):f:n:e.rewind?n<0?c:0:-1:z(D(n)):i&&n!==t&&(n=z(D(t)+(n<t?-1:1)))):n=-1,n}function A(n){return m?(n+f)%f||0:n}function _(){for(var n=f-(P()||m&&a?1:s);g&&0<n--;)if(v(f-1,!0)!==v(n,!0)){n++;break}return q(n,0,f-1)}function z(n){return q(P()?n:s*n,0,c)}function D(n){return P()?Y(n,c):xn((c<=n?f-1:n)/s)}function M(n){n!==x&&(k=x,x=n)}function P(){return!en(e.focus)||e.isNavigation}function I(){return o.state.is([G,rn])&&!!e.waitForTransition}return{mount:function(){S(),t([K,J,"ei"],S),t(Nn,E)},go:function(n,t,i){var r;I()||-1<(r=A(n=function(n){var t=x;{var i,r;C(n)?(r=n.match(/([+\-<>])(\d+)?/)||[],i=r[1],r=r[2],"+"===i||"-"===i?t=O(x+ +(""+i+(+r||1)),x):">"===i?t=r?z(+r):b(!0):"<"===i&&(t=w(!0))):t=m?n:q(n,0,c)}return t}(n)))&&(t||r!==x)&&(M(r),l.move(n,r,k,i))},scroll:function(n,t,i,r){u.Scroll.scroll(n,t,i,function(){var n=A(l.toIndex(d()));M(g?Y(n,c):n),r&&r()})},getNext:b,getPrev:w,getAdjacent:L,getEnd:_,setIndex:M,getIndex:function(n){return n?k:x},toIndex:z,toPage:D,toDest:function(n){return n=l.toIndex(n),y?q(n,0,c):n},hasFocus:P,isBusy:I}},Arrows:function(o,n,t){var i,r,u=Q(o),e=u.on,c=u.bind,f=u.emit,a=t.classes,s=t.i18n,l=n.Elements,d=n.Controller,v=l.arrows,h=l.track,p=v,g=l.prev,m=l.next,y={};function b(){var n=t.arrows;!n||g&&m||(p=v||j("div",a.arrows),g=S(!0),m=S(!1),i=!0,L(p,[g,m]),v||O(p,h)),g&&m&&(an(y,{prev:g,next:m}),ln(p,n?"":"none"),M(p,r=dt+"--"+t.direction),n&&(e([B,Dn,J,V,"ei"],E),c(m,"click",R(k,">")),c(g,"click",R(k,"<")),E(),I([g,m],Kn,h.id),f("arrows:mounted",g,m))),e(K,w)}function w(){x(),b()}function x(){u.destroy(),X(p,r),i?(T(v?[g,m]:p),g=m=null):P([g,m],ut)}function k(n){d.go(n,!0)}function S(n){return hn('<button class="'+a.arrow+" "+(n?a.prev:a.next)+'" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="'+(t.arrowPath||"m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z")+'" />')}function E(){var n,t,i,r;g&&m&&(r=o.index,n=d.getPrev(),t=d.getNext(),i=-1<n&&r<n?s.last:s.prev,r=-1<t&&t<r?s.first:s.next,g.disabled=n<0,m.disabled=t<0,I(g,nn,i),I(m,nn,r),f("arrows:updated",g,m,n,t))}return{arrows:y,mount:b,destroy:x,update:E}},Autoplay:function(n,t,i){var r,o,u=Q(n),e=u.on,c=u.bind,f=u.emit,a=qn(i.interval,n.go.bind(n,">"),function(n){var t=l.bar;t&&_(t,"width",100*n+"%"),f("autoplay:playing",n)}),s=a.isPaused,l=t.Elements,d=(u=t.Elements).root,v=u.toggle,h=i.autoplay,p="pause"===h;function g(){s()&&t.Slides.isEnough()&&(a.start(!i.resetProgress),o=r=p=!1,b(),f(Fn))}function m(n){p=!!(n=void 0===n?!0:n),b(),s()||(a.pause(),f(Xn))}function y(){p||(r||o?m(!1):g())}function b(){v&&(A(v,tn,!p),I(v,nn,i.i18n[p?"play":"pause"]))}function w(n){n=t.Slides.getAt(n);a.set(n&&+z(n.slide,Ct)||i.interval)}return{mount:function(){h&&(i.pauseOnHover&&c(d,"mouseenter mouseleave",function(n){r="mouseenter"===n.type,y()}),i.pauseOnFocus&&c(d,"focusin focusout",function(n){o="focusin"===n.type,y()}),v&&c(v,"click",function(){p?g():m(!0)}),e([H,Tn,J],a.rewind),e(H,w),v&&I(v,Kn,l.track.id),p||g(),b())},destroy:a.cancel,play:g,pause:m,isPaused:s}},Cover:function(n,t,i){var r=Q(n).on;function o(i){t.Slides.forEach(function(n){var t=fn(n.container||n.slide,"img");t&&t.src&&u(i,t,n)})}function u(n,t,i){i.style("background",n?'center/cover no-repeat url("'+t.src+'")':"",!0),ln(t,n?"none":"")}return{mount:function(){i.cover&&(r(Wn,R(u,!0)),r([B,K,J],R(o,!0)))},destroy:R(o,!1)}},Scroll:function(n,c,u){var f,a,t=Q(n),i=t.on,s=t.emit,l=n.state.set,d=c.Move,v=d.getPosition,e=d.getLimit,h=d.exceededLimit,p=d.translate,g=n.is(Mt),m=1;function y(n,t,i,r,o){var u,e=v(),i=(x(),!i||g&&h()||(i=c.Layout.sliderSize(),u=Ln(n)*i*xn(U(n)/i)||0,n=d.toPosition(c.Controller.toDest(n%i))+u),Sn(e,n,1));m=1,t=i?0:t||wn(U(n-e)/1.5,800),a=r,f=qn(t,b,R(w,e,n,o),1),l(rn),s(Tn),f.start()}function b(){l(3),a&&a(),s(V)}function w(n,t,i,r){var o=v(),r=(n+(t-n)*(t=r,(n=u.easingFunc)?n(t):1-Math.pow(1-t,4))-o)*m;p(o+r),g&&!i&&h()&&(m*=.6,U(r)<10&&y(e(h(!0)),600,!1,a,!0))}function x(){f&&f.cancel()}function r(){f&&!f.isPaused()&&(x(),b())}return{mount:function(){i(H,x),i([K,J],r)},destroy:x,scroll:y,cancel:r}},Drag:function(e,o,c){var f,t,u,a,s,l,d,v,n=Q(e),i=n.on,h=n.emit,p=n.bind,g=n.unbind,m=e.state,y=o.Move,b=o.Scroll,w=o.Controller,x=o.Elements.track,k=o.Media.reduce,r=(n=o.Direction).resolve,S=n.orient,E=y.getPosition,L=y.exceededLimit,O=!1;function j(){var n=c.drag;C(!n),a="free"===n}function N(n){var t,i,r;l=!1,d||(t=R(n),i=n.target,r=c.noDrag,cn(i,"."+mt+", ."+vt)||r&&cn(i,r)||!t&&n.button||(w.isBusy()?F(n,!0):(v=t?x:window,s=m.is([G,rn]),u=null,p(v,zt,A,jt),p(v,Dt,_,jt),y.cancel(),b.cancel(),z(n))))}function A(n){var t,i,r,o,u;m.is(6)||(m.set(6),h("drag")),n.cancelable&&(s?(y.translate(f+D(n)/(O&&e.is(Mt)?5:1)),u=200<M(n),t=O!==(O=L()),(u||t)&&z(n),l=!0,h("dragging"),F(n)):U(D(u=n))>U(D(u,!0))&&(t=n,i=c.dragMinThreshold,r=un(i),o=r&&i.mouse||0,r=(r?i.touch:+i)||10,s=U(D(t))>(R(t)?r:o),F(n)))}function _(n){var t,i,r;m.is(6)&&(m.set(3),h("dragged")),s&&(i=function(n){return E()+Ln(n)*Y(U(n)*(c.flickPower||600),a?1/0:o.Layout.listSize()*(c.flickMaxPages||1))}(t=function(n){if(e.is(Pt)||!O){var t=M(n);if(t&&t<200)return D(n)/t}return 0}(t=n)),r=c.rewind&&c.rewindByDrag,k(!1),a?w.scroll(i,0,c.snap):e.is(It)?w.go(S(Ln(t))<0?r?"<":"-":r?">":"+"):e.is(Mt)&&O&&r?w.go(L(!0)?">":"<"):w.go(w.toDest(i),!0),k(!0),F(n)),g(v,zt,A),g(v,Dt,_),s=!1}function T(n){!d&&l&&F(n,!0)}function z(n){u=t,t=n,f=E()}function D(n,t){return I(n,t)-I(P(n),t)}function M(n){return mn(n)-mn(P(n))}function P(n){return t===n&&u||t}function I(n,t){return(R(n)?n.changedTouches[0]:n)["page"+r(t?"Y":"X")]}function R(n){return"undefined"!=typeof TouchEvent&&n instanceof TouchEvent}function C(n){d=n}return{mount:function(){p(x,zt,on,jt),p(x,Dt,on,jt),p(x,_t,N,jt),p(x,"click",T,{capture:!0}),p(x,"dragstart",F),i([B,K],j)},disable:C,isDragging:function(){return s}}},Keyboard:function(t,n,i){var r,o,u=Q(t),e=u.on,c=u.bind,f=u.unbind,a=t.root,s=n.Direction.resolve;function l(){var n=i.keyboard;n&&(r="global"===n?window:a,c(r,Gt,h))}function d(){f(r,Gt)}function v(){var n=o;o=!0,p(function(){o=n})}function h(n){o||((n=Tt(n))===s(Bn)?t.go("<"):n===s(Hn)&&t.go(">"))}return{mount:function(){l(),e(K,d),e(K,l),e(H,v)},destroy:d,disable:function(n){o=n}}},LazyLoad:function(i,n,o){var t=Q(i),r=t.on,u=t.off,e=t.bind,c=t.emit,f="sequential"===o.lazyLoad,a=[Dn,V],s=[];function l(){D(s),n.Slides.forEach(function(r){gn(r.slide,Wt).forEach(function(n){var t=z(n,Ft),i=z(n,Xt);t===n.src&&i===n.srcset||(t=o.classes.spinner,t=fn(i=n.parentElement,"."+t)||j("span",t,i),s.push([n,r,t]),n.src||ln(n,"none"))})}),(f?p:(u(a),r(a,d),d))()}function d(){(s=s.filter(function(n){var t=o.perPage*((o.preloadPages||1)+1)-1;return!n[1].isWithin(i.index,t)||v(n)})).length||u(a)}function v(n){var t=n[0];M(n[1].slide,Et),e(t,"load error",R(h,n)),I(t,"src",z(t,Ft)),I(t,"srcset",z(t,Xt)),P(t,Ft),P(t,Xt)}function h(n,t){var i=n[0],r=n[1];X(r.slide,Et),"error"!==t.type&&(T(n[2]),ln(i,""),c(Wn,i,r),c(jn)),f&&p()}function p(){s.length&&v(s.shift())}return{mount:function(){o.lazyLoad&&(l(),r(J,l))},destroy:R(D,s),check:d}},Pagination:function(l,n,d){var v,h,t=Q(l),p=t.on,g=t.emit,m=t.bind,y=n.Slides,b=n.Elements,w=n.Controller,x=w.hasFocus,r=w.getIndex,e=w.go,c=n.Direction.resolve,k=b.pagination,S=[];function E(){v&&(T(k?o(v.children):v),X(v,h),D(S),v=null),t.destroy()}function L(n){e(">"+n,!0)}function O(n,t){var i=S.length,r=Tt(t),o=A(),u=-1,o=(r===c(Hn,!1,o)?u=++n%i:r===c(Bn,!1,o)?u=(--n+i)%i:"Home"===r?u=0:"End"===r&&(u=i-1),S[u]);o&&(dn(o.button),e(">"+u),F(t,!0))}function A(){return d.paginationDirection||d.direction}function _(n){return S[w.toPage(n)]}function z(){var n,t=_(r(!0)),i=_(r());t&&(X(n=t.button,tn),P(n,Qn),I(n,$,-1)),i&&(M(n=i.button,tn),I(n,Qn,!0),I(n,$,"")),g("pagination:updated",{list:v,items:S},t,i)}return{items:S,mount:function n(){E(),p([K,J,"ei"],n);var t=d.pagination;if(k&&ln(k,t?"":"none"),t){p([H,Tn,V],z);var t=l.length,i=d.classes,r=d.i18n,o=d.perPage,u=x()?w.getEnd()+1:kn(t/o);M(v=k||j("ul",i.pagination,b.track.parentElement),h=gt+"--"+A()),I(v,Z,"tablist"),I(v,nn,r.select),I(v,nt,A()===Jn?"vertical":"");for(var e=0;e<u;e++){var c=j("li",null,v),f=j("button",{class:i.page,type:"button"},c),a=y.getIn(e).map(function(n){return n.slide.id}),s=!x()&&1<o?r.pageX:r.slideX;m(f,"click",R(L,e)),d.paginationKeyboard&&m(f,"keydown",R(O,e)),I(c,Z,"presentation"),I(f,Z,"tab"),I(f,Kn,a.join(" ")),I(f,nn,On(s,e+1)),I(f,$,-1),S.push({li:c,button:f,page:e})}z(),g("pagination:mounted",{list:v,items:S},_(l.index))}},destroy:E,getAt:_,update:z}},Sync:function(i,n,t){var r=t.isNavigation,o=t.slideFocus,u=[];function e(){var n,t;i.splides.forEach(function(n){n.isParent||(f(i,n.splide),f(n.splide,i))}),r&&(n=Q(i),(t=n.on)(Mn,s),t(Yn,l),t([B,K],a),u.push(n),n.emit(Gn,i.splides))}function c(){u.forEach(function(n){n.destroy()}),D(u)}function f(n,r){n=Q(n);n.on(H,function(n,t,i){r.go(r.is(Pt)?i:n)}),u.push(n)}function a(){I(n.Elements.list,nt,t.direction===Jn?"vertical":"")}function s(n){i.go(n.index)}function l(n,t){b(Yt,Tt(t))&&(s(n),F(t))}return{setup:R(n.Media.set,{slideFocus:en(o)?r:o},!0),mount:e,destroy:c,remount:function(){c(),e()}}},Wheel:function(e,c,f){var n=Q(e).bind,a=0;function t(n){var t,i,r,o,u;n.cancelable&&(t=(u=n.deltaY)<0,i=mn(n),r=f.wheelMinThreshold||0,o=f.wheelSleep||0,U(u)>r&&o<i-a&&(e.go(t?"<":">"),a=i),u=t,f.releaseWheel&&!e.state.is(G)&&-1===c.Controller.getAdjacent(u)||F(n))}return{mount:function(){f.wheel&&n(c.Elements.track,"wheel",t,jt)}}},Live:function(n,t,i){var r=Q(n).on,o=t.Elements.track,u=i.live&&!i.isNavigation,e=j("span",wt),c=qn(90,R(f,!1));function f(n){I(o,rt,n),n?(L(o,e),c.start()):(T(e),c.cancel())}function a(n){u&&I(o,it,n?"off":"polite")}return{mount:function(){u&&(a(!t.Autoplay.isPaused()),I(o,ot,!0),e.textContent="…",r(Fn,R(a,!0)),r(Xn,R(a,!1)),r([Dn,V],R(f,!0)))},disable:a,destroy:function(){P(o,[it,ot,rt]),T(e)}}}}),qt={type:"slide",role:"region",speed:400,perPage:1,cloneStatus:!0,arrows:!0,pagination:!0,paginationKeyboard:!0,interval:5e3,pauseOnHover:!0,pauseOnFocus:!0,resetProgress:!0,easing:"cubic-bezier(0.25, 1, 0.5, 1)",drag:!0,direction:"ltr",trimSpace:!0,focusableNodes:"a, button, textarea, input, select, iframe",live:!0,classes:{slide:at,clone:st,arrows:dt,arrow:vt,prev:ht,next:pt,pagination:gt,page:mt,spinner:i+"spinner"},i18n:{prev:"Previous slide",next:"Next slide",first:"Go to first slide",last:"Go to last slide",slideX:"Go to slide %s",pageX:"Go to page %s",play:"Start autoplay",pause:"Pause autoplay",carousel:"carousel",slide:"slide",select:"Select a slide to show",slideLabel:"%s of %s"},reducedMotion:{speed:0,rewindSpeed:0,autoplay:"pause"}};function Bt(n,t,i){var r=t.Slides;function o(){r.forEach(function(n){n.style("transform","translateX(-"+100*n.index+"%)")})}return{mount:function(){Q(n).on([B,J],o)},start:function(n,t){r.style("transition","opacity "+i.speed+"ms "+i.easing),p(t)},cancel:on}}function Ht(u,n,e){var c,f=n.Move,a=n.Controller,s=n.Scroll,t=n.Elements.list,l=R(_,t,"transition");function i(){l(""),s.cancel()}return{mount:function(){Q(u).bind(t,"transitionend",function(n){n.target===t&&c&&(i(),c())})},start:function(n,t){var i=f.toPosition(n,!0),r=f.getPosition(),o=function(n){var t=e.rewindSpeed;if(u.is(Mt)&&t){var i=a.getIndex(!0),r=a.getEnd();if(0===i&&r<=n||r<=i&&0===n)return t}return e.speed}(n);1<=U(i-r)&&1<=o?e.useScroll?s.scroll(i,o,!1,t):(l("transform "+o+"ms "+e.easing),f.translate(i,!0),c=t):(f.jump(n),t())},cancel:i}}t=function(){function i(n,t){this.event=Q(),this.Components={},this.state=s(1),this.splides=[],this.n={},this.t={};n=C(n)?pn(document,n):n;bn(n,n+" is invalid."),t=d({label:z(this.root=n,nn)||"",labelledby:z(n,Zn)||""},qt,i.defaults,t||{});try{d(t,JSON.parse(z(n,f)))}catch(n){bn(!1,"Invalid JSON")}this.n=Object.create(d({},t))}var n=i.prototype;return n.mount=function(n,t){var i=this,r=this.state,o=this.Components;return bn(r.is([1,7]),"Already mounted!"),r.set(1),this.i=o,this.r=t||this.r||(this.is(It)?Bt:Ht),this.t=n||this.t,w(an({},Ut,this.t,{Transition:this.r}),function(n,t){n=n(i,o,i.n);(o[t]=n).setup&&n.setup()}),w(o,function(n){n.mount&&n.mount()}),this.emit(B),M(this.root,"is-initialized"),r.set(3),this.emit("ready"),this},n.sync=function(n){return this.splides.push({splide:n}),n.splides.push({splide:this,isParent:!0}),this.state.is(3)&&(this.i.Sync.remount(),n.Components.Sync.remount()),this},n.go=function(n){return this.i.Controller.go(n),this},n.on=function(n,t){return this.event.on(n,t),this},n.off=function(n){return this.event.off(n),this},n.emit=function(n){var t;return(t=this.event).emit.apply(t,[n].concat(o(arguments,1))),this},n.add=function(n,t){return this.i.Slides.add(n,t),this},n.remove=function(n){return this.i.Slides.remove(n),this},n.is=function(n){return this.n.type===n},n.refresh=function(){return this.emit(J),this},n.destroy=function(t){void 0===t&&(t=!0);var n=this.event,i=this.state;return i.is(1)?Q(this).on("ready",this.destroy.bind(this,t)):(w(this.i,function(n){n.destroy&&n.destroy(t)},!0),n.emit(a),n.destroy(),t&&D(this.splides),i.set(7)),this},Jt(i,[{key:"options",get:function(){return this.n},set:function(n){this.i.Media.set(n,!0,!0)}},{key:"length",get:function(){return this.i.Slides.getLength(!0)}},{key:"index",get:function(){return this.i.Controller.getIndex()}}]),i}();return t.defaults={},t.STATES=r,t},"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).Splide=t();
//# sourceMappingURL=splide.min.js.map


/* Modal
========================================================================== */

var last_focused_element = null;

document.addEventListener('DOMContentLoaded', function () {
  initModals();

  const open_init_modals = document.querySelectorAll('.modal.openinit');
  if (open_init_modals.length) {
    open_init_modals.forEach(modal => {
      openModal(modal.id);
    });
  }

  document.body.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeModal();
    }
  });
});

/**
 * Init modals
 */
function initModals(){
  const modals = document.querySelectorAll('.modal:not(.init)');
  if(modals.length){
    modals.forEach(modal => {
      modal.classList.add('init');
      modal.addEventListener('click', function (e) {
        if (e.target !== this) return;
        closeModal();
      });
    });
  }

  initModalOpenButtons();
  initModalCloseButtons();
}

/**
 * Add event listeners to all modal open buttons
 */
function initModalOpenButtons() {
  const modal_buttons = document.querySelectorAll('.modal-opener:not(.init)');
  if (modal_buttons.length){
    modal_buttons.forEach(button => {
      button.classList.add('init');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(button.dataset.modal);
      });
    });
  }
}

/**
 * Add event listeners to all modal close buttons
 */
function initModalCloseButtons(){
  const modal_close_buttons = document.querySelectorAll('.modal .btnclose:not(.init)');
  if (modal_close_buttons.length){
    modal_close_buttons.forEach(button => {
      button.classList.add('init');
      button.addEventListener('click', function (event) {
        closeModal();
      });
    });
  }
}


/**
 * Open a modal
 */
function openModal(modalID) {
  const modal = document.getElementById(modalID);
  if (modal) {
    modal.classList.add('open');
    document.body.classList.add('modal-open');
    trapModalFocus(modal);

    //SET FOCUS ON MODAL -- timeout needed otherwise cannot focus on hidden element
    setTimeout(function(){
      setModalFocus(modal);
    }, 100);

    last_focused_element = document.activeElement;

    //VIDEO AUTOPLAY
    if(modal.classList.contains('modal-video')){
      setTimeout(() => {
        console.log('start video modal');
        initVideo(modal.querySelector('.videoPlay'), true, false);
      }, 500);
    }
  }
}

/**
 * Close all modals
 */
function closeAllModals() {
  const modals = document.querySelectorAll('.modal.open');
  if (modals) {
    modals.forEach(modal => {
      closeModal(modal.id);
    });
  }
}

/**
 * Close a modal
 * If no modal_id is provided, close the last opened modal
 */
function closeModal(modal_id) {
  if(!modal_id){
    //get last modal id in dom
    const modals = document.querySelectorAll('.modal.open');
    modal_id = modals ? modals[modals.length - 1].id : null;
  }

  const modal = document.getElementById(modal_id);

  if(modal){
    modal.classList.remove('open');
    modal.dispatchEvent(new Event('close'));

    //stop video
    if (modal.classList.contains('modal-video')) {
      window.stopVideo(modal.querySelector('iframe'))
    }
  }

  const modals = document.querySelectorAll('.modal.open');
  if(!modals.length){
    document.body.classList.remove('modal-open');
    if (last_focused_element) {
      last_focused_element.focus();
      last_focused_element = null;
    }
  }
}

/**
 * Generate a modal with AJAX
 */
window.gblGenerateModal = function (modalContent, open, modal_class = "") {
  fetch(frontendajax.ajaxurl, {
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: new URLSearchParams({
      'action': 'get_modal_ajax',
      'content': encodeURI(modalContent),
      'modal_class': modal_class
    })
  })
    .then(response => response.json())
    .then(response => {
      document.body.querySelector('.modalWrapper').insertAdjacentHTML('beforeend', response.modal); // Afficher le HTML
      if (open) {
        openModal(response.id);
      }
      initModals();
      return response.id;
    });
}

/**
 * Set focus on first focusable element in modal
 */
function setModalFocus(element){
  var focusable_elements = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
  if (focusable_elements.length){
    focusable_elements[0].focus();
  }
}

/**
 * Trap focus inside modal while opened
 */
function trapModalFocus(element) {
  var focusable_elements = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
  var first_focusable = focusable_elements[0];
  var last_focusable = focusable_elements[focusable_elements.length - 1];
  var KEYCODE_TAB = 9;

  element.addEventListener('keydown', function (e) {
    var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) /* shift + tab */ {
      if (document.activeElement === first_focusable) {
        last_focusable.focus();
        e.preventDefault();
      }
    } else /* tab */ {
      if (document.activeElement === last_focusable) {
        first_focusable.focus();
        e.preventDefault();
      }
    }
  });
}

/**
 * MENU NAV
*/
var gblMouseDown = false;
document.querySelectorAll("a").forEach(function (el) {
  el.addEventListener("focus", function () {
    if (!gblMouseDown) {
      document.querySelectorAll(".sub-menu-wrapper.open").forEach(function (el) {
        el.classList.remove("open")
      })

      document.querySelectorAll("li.menu-item-has-children.active > a").forEach(function (el) {
        el.setAttribute('aria-expanded', 'false')
      })
      document.querySelectorAll("li.menu-item-has-children.active").forEach(function (el) {
        el.classList.remove("active");
      })

      var parent = this.closest("li.menu-item-has-children");
      if (parent) {
        parent.classList.add("active");

        let sm = parent.querySelector('.sub-menu-wrapper');
        if(sm){
          sm.classList.add('open');
        }

        document.querySelectorAll("li.menu-item-has-children.active > a").forEach(function (el) {
          el.setAttribute('aria-expanded', 'true')
        })
      }
    }
    gblMouseDown = false;
  })
})

/**
 * TAB NAV
 */
var navtabon_timeout = null;
document.addEventListener('keydown', function (e) {
  if (e.code == "Tab") {

    document.body.classList.add("navtab-on");
    if (navtabon_timeout) {
      window.clearTimeout(navtabon_timeout);
    }

    navtabon_timeout = setTimeout(() => {
      removeAutoNavTabOn();
    }, 10 * 1000);

    if (e.target.classList.contains("noTab")) {
      //next
      document.activeElement.dispatchEvent(new KeyboardEvent("keypress", {
        key: "Tab"
      }));
      e.preventDefault();
    }
  }
});

function removeAutoNavTabOn() {
  document.body.classList.remove("navtab-on");
}

const a11y_active = document.querySelector("#modal-a11y") !== null
if (a11y_active){

  /**
   * DARK MODE ON LOAD
   *
   * Set dark mode ON if no option saved AND device theme is dark
   */
  // const isAlreadySet = localStorage.getItem("a11yPremium") || localStorage.getItem("a11y");
  // if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches && !isAlreadySet) {
  //   const a11yContrast = document.querySelector('.a11yOption[data-id="a42-ac-dark-contrast"]');
  //   if (a11yContrast) {
  //     a11y_update_default_theme();
  //   }
  // }

  /**
   * DARK MODE ON CHANGE
   *
   * Set/remove dark mode when device theme is changed
   */
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
    a11y_update_default_theme();
  });

  function a11y_update_default_theme(){
    const a11yContrast = document.querySelector('.a11yOption[data-id="a42-ac-dark-contrast"]');

    if (!a11yContrast) {
      return;
    }

    const is_dark_theme = window.matchMedia('(prefers-color-scheme: dark)').matches
    if (is_dark_theme) {
      a11yContrast.classList.add('active');
      update_a11y_localstorage();
      manage_a11y_options_body_class();
    } else {
      a11yContrast.classList.remove('active');
      update_a11y_localstorage();
      manage_a11y_options_body_class();
    }
  }

  /**
   * A11Y OPTIONS
   */
  manage_a11y_options_body_class();
  document.querySelectorAll(".a11yOption").forEach(function (el) {
    el.addEventListener("click", function (e) {
      var type = this.dataset.group;
      document.querySelectorAll('.a11yOption[data-group=' + type + ']').forEach(function (el) {
        el.classList.remove("active")
        document.querySelector('body').classList.remove(el.dataset.id)
      })
      this.classList.add("active");

      update_a11y_localstorage();
      manage_a11y_options_body_class();

      e.preventDefault();
    })
  })

}



/**
 * SWITCH HIGH CONTRAST
 */
const a11yToggleBtn = document.querySelector('#a11y-toggle');
if (a11yToggleBtn) {

  if (localStorage.getItem("a11yContrastOnly")){
    a11yToggleBtn.classList.add('active');
    body.classList.add('a42-ac-light-contrast');
  }

  a11yToggleBtn.addEventListener("click", function (e) {
    const body = document.querySelector('body');

    if (e.target.classList.contains('active')) {
      e.target.classList.remove('active');
      body.classList.remove('a42-ac-light-contrast');
      localStorage.removeItem("a11yContrastOnly");
    } else {
      e.target.classList.add('active');
      body.classList.add('a42-ac-light-contrast');
      localStorage.setItem("a11yContrastOnly", 'active');
    }

    e.preventDefault();
  })
}

function update_a11y_localstorage() {
  var a11y = new Array();
  document.querySelectorAll('.a11yOption.active').forEach(function (el) {
    var id = el.dataset.id;
    //if (!id.match('default')) {
    a11y.push(id);
    //}
  })

  if (a11y.length === 0) {
    localStorage.removeItem("a11yPremium");
  } else {
    localStorage.setItem("a11yPremium", JSON.stringify(a11y));
  }
}

function manage_a11y_options_body_class() {
  a11y_options_reset();
  var a11y = JSON.parse(localStorage.getItem("a11yPremium"));
  if (Array.isArray(a11y)) {
    a11y.forEach(async (item) => {
      if (!item.match('default')) {
        document.querySelector('body').classList.add(item);
      }

      var option = document.querySelector('.a11yOption[data-id=' + item + ']');
      if (option) {
        var type = option.dataset.group;
        var options = document.querySelectorAll('.a11yOption[data-group=' + type + ']');
        if (options) {
          options.forEach(function (item) {
            item.classList.remove('active')
          })
        }
        option.classList.add("active")
      }
    });
  }
}

/**
 * RESET A11Y OPTIONS
 * - remove all active class from options
 * - set default option for each type
 */
function a11y_options_reset() {
  //RESET ALL OPTIONS
  const options = document.querySelectorAll('.a11yOption');
  options.forEach(function (item) {
    item.classList.remove('active');
  })

  //CONTRAST
  document.body.classList.remove('a42-ac-high-contrast');
  document.body.classList.remove('a42-ac-dark-contrast');
  document.body.classList.remove('a42-ac-shade-grey');
  document.querySelector('.a11yOption[data-id=a42-ac-default-contrast]').classList.add("active");

  //SPACING
  document.body.classList.remove('a42-ac-spacing');
  document.querySelector('.a11yOption[data-id=a42-ac-default-spacing]').classList.add("active");

  //DYSLEXIE
  document.body.classList.remove('a42-ac-dyslexie');
  document.querySelector('.a11yOption[data-id=a42-ac-default-dyslexie]').classList.add("active");
}

/* Client
========================================================================== */

/* Common
========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  // Scrollbar width for correct viewport CSS
  //----------------
  document.documentElement.style.setProperty('--sw', (window.innerWidth - document.documentElement.clientWidth) + "px");

  // Add apple class to body if device is apple
  // (Was in video.js, moved here on 2025-02-03)
  //----------------
  if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {
    document.body.className += ' ' + 'apple';
  }



  // Email robots
  //----------------
  document.querySelectorAll(".clic-email-convert").forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      const mail = atob(element.getAttribute("data-email"));
      if (!element.getAttribute("href")) {
        element.setAttribute("href", "mailto:" + mail);
        element.innerHTML = mail;
      }
    });
  });

  // Get viewport height in pixels and keep 80% of it
  //----------------
  // var viewportHeight = window.innerHeight;
  // lightbox.option({
  //   'resizeDuration': 200,
  //   'wrapAround': true,
  //   'disableScrolling': true,
  //   'showImageNumberLabel': false,
  //   'maxHeight': viewportHeight * 0.8,
  //   'positionFromTop': viewportHeight * 0.1
  // });
  // document.querySelectorAll("a.btn-lightbox").forEach(function (element) {
  //   element.setAttribute("data-lightbox", "ddd");
  // });

  var groups = [];
  document.querySelectorAll('a[data-lightbox]').forEach(function (element) {
    var group = element.getAttribute('data-lightbox');
    if (!groups.includes(group)) {
      groups.push(group);
    }
  });


  /**
   * Init lightbox
   */
  var last_focused_element = null;
  groups.forEach(function (group) {
    let gallery = new SimpleLightbox('a[data-lightbox="' + group + '"]', {
      download: 'Télécharger',
      captions: true,
      spinner: true,
      overlayOpacity: 1,
      navText: ['', ''],
      closeText: '',
      uniqueImages: false,
      fileExt: 'jpg|jpeg|png|gif|svg'
    });

    gallery.on('shown.simplelightbox', function (event) {
      last_focused_element = document.activeElement;
      setLightboxFocus();
      trapLightboxFocus();

    })
    gallery.on('close.simplelightbox', function (event) {
      if (last_focused_element) {
        last_focused_element.focus();
        last_focused_element = null;
      }
    })
  });

  /**
   * Set focus on first focusable element in lightbox
   */
  function setLightboxFocus() {
    const lightbox = document.querySelector('.simple-lightbox');
    if (lightbox) {
      var focusableEls = lightbox.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
      if (focusableEls.length) {
        focusableEls[0].focus();
      }
    }
  }

  /**
   * Trap focus inside lightbox while opened
   */
  function trapLightboxFocus() {
    const lightbox = document.querySelector('.simple-lightbox');
    if (lightbox) {
      var focusableEls = lightbox.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
      var firstFocusableEl = focusableEls[0];
      var lastFocusableEl = focusableEls[focusableEls.length - 1];
      var KEYCODE_TAB = 9;

      lightbox.addEventListener('keydown', function (e) {
        var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) /* shift + tab */ {
          if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
          }
        } else /* tab */ {
          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      });
    }
  }

  /**
   * Scroll to top
   */
  document.querySelectorAll(".scrollTop").forEach((element) => {
    element.addEventListener("click", event => {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  });


  /**
   * CF7 acceptance input change
   */
  document.querySelectorAll('.wpcf7-acceptance input').forEach((input) => {
    input.addEventListener('change', function () {
      updateInputSubmitWrapper();
    });
  });

  /**
   * AppHeight mobile fix
   */
  window.addEventListener('resize', appHeight);
  appHeight();

  /**
   * Init functions
   */
  initReadMore();
  updateInputSubmitWrapper(); //force add class disabled on init
});


/**
 * Read more
 */
function initReadMore() {
  document.querySelectorAll(".read-more-excerpt:not(.init)").forEach(function (element) {
    element.classList.add("init");
    element.addEventListener("click", function () {
      element.style.display = "none";
      element.closest("article").querySelector(".text-end").style.display = "block";
      element.closest("article").querySelector(".etc").style.display = "none";
    });
  });
}


/**
 * Add DISABLED CLASS on input wrapper if disabled
 */
function updateInputSubmitWrapper() {
  document.querySelectorAll('.wpcf7-form .submit-wrapper').forEach((wrapper) => {
    const input = wrapper.querySelector('input[type=submit]');
    if (input) {
      if (input.disabled) {
        wrapper.classList.remove('disabled');
      } else {
        wrapper.classList.add('disabled');
      }
    }
  });
}


// Bug mobile height menu 100vh
//----------------
function appHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');
}



/**
 * Scroll to anchor on page load
 */
const hash = location.hash;
if (hash != "") {
  scrollToIfExist(hash);
}

/**
 * Scroll to anchor
 */
document.querySelectorAll('[href^="#_"]').forEach(anchor => {
  anchor.addEventListener('click', event => {
    //event.preventDefault();
    scrollToIfExist(anchor.getAttribute('href'));
  })
})


function scrollToIfExist(anchor) {

  let element = document.querySelector(anchor);
  if (!element) {
    element = document.querySelector(anchor.replace('#_', '#'));
  }

  if (element) {
    //scroll-margin
    element.style.scrollMarginTop = "var(--height-scrolltop)"; // header heigt
    element.scrollIntoView({ behavior: 'smooth' });
  }
}


document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains("gammes-template-single-gammes-products")) {
    const toggleBtn = document.getElementById("converter-toggle");
    const popup = document.getElementById("converter-popup");

    const cfmInput = document.getElementById('converter-cfm');
    const m3hInput = document.getElementById('converter-m3h');
    const psiInput = document.getElementById('converter-psi');
    const barInput = document.getElementById('converter-bar');

    if (!toggleBtn || !popup || !cfmInput || !m3hInput || !psiInput || !barInput) {
      console.error("Converter: One or more required elements not found");
      return;
    }

    function convertUnits(action, value, targetElement) {
      if (typeof frontendajax === 'undefined') {
        console.error("frontendajax is not defined. AJAX conversion won't work.");
        return;
      }

      const ajaxUrl = frontendajax.ajaxurl;

      const xhr = new XMLHttpRequest();
      xhr.open('POST', ajaxUrl, true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            if (response.success) {
              // Update target input with converted value
              targetElement.value = response.data.toFixed(2);
            } else {
              console.error('Conversion error:', response.data);
            }
          } catch (e) {
            console.error('Error parsing response:', e);
          }
        }
      };

      const data = 'action=' + action + '&value=' + encodeURIComponent(value);

      xhr.send(data);
    }

    // CFM to m³/h conversion
    cfmInput.addEventListener('input', function() {
      try {
        if (this.value.trim() === '') {
          m3hInput.value = '';
          return;
        }

        const cfmValue = parseFloat(this.value);
        if (!isNaN(cfmValue)) {
          convertUnits('cfm_to_m3h', cfmValue, m3hInput);
        }
      } catch (error) {
        console.error('Error in CFM conversion:', error);
      }
    });

    // m³/h to CFM conversion
    m3hInput.addEventListener('input', function() {
      try {
        if (this.value.trim() === '') {
          cfmInput.value = '';
          return;
        }

        const m3hValue = parseFloat(this.value);
        if (!isNaN(m3hValue)) {
          convertUnits('m3h_to_cfm', m3hValue, cfmInput);
        }
      } catch (error) {
        console.error('Error in m³/h conversion:', error);
      }
    });

    // PSI to bar conversion
    psiInput.addEventListener('input', function() {
      try {
        if (this.value.trim() === '') {
          barInput.value = '';
          return;
        }

        const psiValue = parseFloat(this.value);
        if (!isNaN(psiValue)) {
          convertUnits('psi_to_bar', psiValue, barInput);
        }
      } catch (error) {
        console.error('Error in PSI conversion:', error);
      }
    });

    // bar to PSI conversion
    barInput.addEventListener('input', function() {
      try {
        if (this.value.trim() === '') {
          psiInput.value = '';
          return;
        }

        const barValue = parseFloat(this.value);
        if (!isNaN(barValue)) {
          convertUnits('bar_to_psi', barValue, psiInput);
        }
      } catch (error) {
        console.error('Error in bar conversion:', error);
      }
    });

    toggleBtn.addEventListener("click", () => {
      popup.style.display = (popup.style.display === "none" || popup.style.display === "") ? "block" : "none";
    });

    document.addEventListener("click", (e) => {
      if (!popup.contains(e.target) && e.target !== toggleBtn) {
        popup.style.display = "none";
      }
    });
  }
});

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie() {
    let user = getCookie("username");
    if (user != "") {
        alert("Welcome again " + user);
    } else {
        user = prompt("Please enter your name:", "");
        if (user != "" && user != null) {
            setCookie("username", user, 365);
        }
    }
} 

const FilterManager = (() => {
  const CONFIG = {
    SPLIDE_DELAY: 300,
    ANIMATION_DELAY: 250,
    DEBOUNCE_DELAY: 300,
    SPLIDE_OPTIONS: {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      padding: { left: 50, right: 100 },
      trimSpace: false,
      pagination: false,
      arrows: false
    }
  };

  const DOMCache = {
    elements: new Map(),
    get(selector) {
      if (!this.elements.has(selector)) {
        this.elements.set(selector, document.querySelector(selector));
      }
      return this.elements.get(selector);
    },
    getAll(selector) {
      return document.querySelectorAll(selector);
    },
    invalidate(selector) {
      this.elements.delete(selector);
    }
  };

  const Utils = {
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    validateFormData(data) {
      return Object.values(data).every(value => value && value.trim() !== '');
    },

    sanitizeValue(value) {
      return value ? value.toString().trim() : '';
    },

    showNotification(message, type = 'error') {
      console.log(`[${type.toUpperCase()}] ${message}`);
      if (type === 'error') {
        alert(message);
      }
    }
  };

  const AjaxHandler = {
    activeRequests: new Map(),

    async makeRequest(action, params = {}) {
      if (this.activeRequests.has(action)) {
        this.activeRequests.get(action).abort();
      }

      const controller = new AbortController();
      this.activeRequests.set(action, controller);

      const formData = new URLSearchParams();
      formData.append('action', action);
      Object.entries(params).forEach(([key, value]) => {
        formData.append(key, value);
      });

      try {
        const response = await fetch(frontendajax.ajaxurl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          },
          body: formData,
          signal: controller.signal
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        this.activeRequests.delete(action);
        return data;
      } catch (error) {
        this.activeRequests.delete(action);
        if (error.name === 'AbortError') {
          console.log('Request aborted');
          return null;
        }
        throw error;
      }
    }
  };

  const SplideManager = {
    instances: new Map(),

    destroyAll() {
      this.instances.forEach((instance, element) => {
        if (instance && typeof instance.destroy === 'function') {
          instance.destroy();
        }
      });
      this.instances.clear();
    },

    create(element, options = CONFIG.SPLIDE_OPTIONS) {
      if (!element || typeof Splide === 'undefined') {
        console.error('Splide element or library not available');
        return null;
      }

      try {
        if (this.instances.has(element)) {
          this.instances.get(element).destroy();
        }

        const splide = new Splide(element, options);
        
        if (element.querySelector('.splide__track') &&
            element.querySelector('.splide__list') &&
            element.querySelectorAll('.splide__slide').length > 0) {
          splide.mount();
          this.instances.set(element, splide);
          return splide;
        }
      } catch (error) {
        console.error('Error initializing Splide:', error);
      }
      return null;
    },

    initializeSliders(container) {
      setTimeout(() => {
        const sliders = container.querySelectorAll('.splide');
        sliders.forEach(slider => this.create(slider));
      }, CONFIG.SPLIDE_DELAY);
    }
  };

  const GammeFilters = {
    init() {
      const form = DOMCache.get('.filters');
      if (!form) return;

      const filterButton = DOMCache.get('#filter-button');
      const resetButton = DOMCache.get('.btnreset');

      if (filterButton) {
        filterButton.addEventListener('click', Utils.debounce(this.handleFilter.bind(this), CONFIG.DEBOUNCE_DELAY));
      }

      if (resetButton) {
        resetButton.addEventListener('click', Utils.debounce(this.handleReset.bind(this), CONFIG.DEBOUNCE_DELAY));
      }
    },

    getFormData() {
      return {
        parent_id: DOMCache.get('.filters')?.getAttribute('data-parent-id') || '',
        airflow: Utils.sanitizeValue(DOMCache.get('#airflow')?.value),
        air_temp: Utils.sanitizeValue(DOMCache.get('#air_temp')?.value),
        humidity: Utils.sanitizeValue(DOMCache.get('#humidity')?.value),
        altitude: Utils.sanitizeValue(DOMCache.get('#altitude')?.value)
      };
    },

    async handleFilter() {
      const formData = this.getFormData();
      
      if (!Utils.validateFormData(formData)) {
        Utils.showNotification('All fields are required');
        return;
      }

      await this.processRequest('filter_compressors', formData);
    },

    async handleReset(e) {
      e?.preventDefault();
      const form = DOMCache.get('.filters');
      form?.reset();
      
      const formData = { parent_id: form?.getAttribute('data-parent-id') || '' };
      await this.processRequest('filter_compressors', formData);
    },

    async processRequest(action, params) {
      const section = DOMCache.get('#section-gammes');
      
      try {
        section?.classList.add('loading');
        
        const data = await AjaxHandler.makeRequest(action, params);
        
        if (!data) return;

        if (data.success) {
          this.updateResults(data);
        } else {
          console.error('Error processing filter request:', data.message);
          Utils.showNotification('Error processing your request. Please try again.');
        }
      } catch (error) {
        console.error('Request failed:', error);
        Utils.showNotification('Error processing your request. Please try again.');
      } finally {
        section?.classList.remove('loading');
      }
    },

    updateResults(data) {
      const section = DOMCache.get('#section-gammes');
      if (!section) return;

      const responseData = data.data || data;
      const content = responseData.content;
      const matchedCount = responseData.matched_count;

      if (matchedCount === 0) {
        section.innerHTML = content || '<div class="no-results"><p>No results found. Please check your data or ask someone for help.</p></div>';
      } else if (content) {
        section.innerHTML = `<div class="splide gammes-slider wrapper-grid">${content}</div>`;
        SplideManager.initializeSliders(section);
      }
    }
  };

  const ArticleFilters = {
    init() {
      if (DOMCache.getAll('.article-filters').length === 0) return;

      this.wrapper = DOMCache.get('.wrapper-grid.card-wrapper');
      this.loader = DOMCache.get('.loadMoreWrapper');
      this.infinite = this.loader?.querySelector('.loadMorePost');

      if (!this.wrapper || !this.loader || !this.infinite) return;

      document.addEventListener('click', this.handleFilterClick.bind(this));
    },

    async handleFilterClick(event) {
      if (!event.target.classList.contains('article-filters')) return;

      event.preventDefault();
      
      const clicker = event.target;
      clicker.classList.toggle('active');
      clicker.closest('li')?.classList.toggle('active');

      const query = Array.from(DOMCache.getAll('.article-filters.active'))
        .map(filter => filter.getAttribute('data-filter'))
        .filter(Boolean);

      this.hideArticles();
      await this.loadFilteredArticles(query);
    },

    hideArticles() {
      const articles = this.wrapper.querySelectorAll('article');
      articles.forEach(article => {
        article.style.display = 'none';
      });
    },

    async loadFilteredArticles(query) {
      try {
        const params = {
          gtype: this.infinite.getAttribute('data-type'),
          nbPosts: this.infinite.getAttribute('data-nb'),
          tax: query.join(',')
        };

        const data = await AjaxHandler.makeRequest('get_filtererd_items', params);
        
        if (data) {
          this.updateArticleResults(data);
        }
      } catch (error) {
        console.error('Error loading filtered articles:', error);
      }
    },

    updateArticleResults(data) {
      this.loader.classList.remove('loading');
      this.wrapper.innerHTML = data.content;
      
      this.infinite.style.display = 'block';
      this.infinite.setAttribute('data-max', data.max);
      this.infinite.setAttribute('data-page', 2);
      this.infinite.setAttribute('data-tax', data.taxo);

      if (data.max <= 1) {
        this.infinite.style.display = 'none';
      }

      setTimeout(() => {
        this.wrapper.querySelectorAll('article').forEach(article => {
          article.classList.remove('hidden');
        });
      }, CONFIG.ANIMATION_DELAY);
    }
  };

  return {
    init() {
      GammeFilters.init();
      ArticleFilters.init();
    },
    
    destroy() {
      SplideManager.destroyAll();
      DOMCache.elements.clear();
    }
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  FilterManager.init();
});

window.addEventListener('beforeunload', () => {
  FilterManager.destroy();
});


window.dataLayer = window.dataLayer || [];

function consentGrantedAdStorage() {
    gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'wait_for_update': 2000,
    });
}

if (document.cookie.indexOf('cookie-agreed=2') > -1) {
    consentGrantedAdStorage();
}

/* Height menu mobile
========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
	var vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh+'px');

	window.addEventListener('resize', function(event){
		var vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', vh+'px');
	});
});


/* Pagination
========================================================================== */
document.addEventListener('DOMContentLoaded', function () {

  if (document.querySelector(".infinite")) {
    window.addEventListener('scroll', function () {
      if (!document.body.classList.contains("loading") && window.scrollY + document.documentElement.clientHeight >= document.querySelector(".infinite").offsetTop) {
        document.querySelector(".loadMorePost").click();
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('loadMorePost')) {
      var clicker = event.target;
      var loader = clicker.closest(".loadMoreWrapper");
      var page = parseInt(clicker.getAttribute("data-page"));

      if (page <= parseInt(clicker.getAttribute("data-max"))) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', frontendajax.ajaxurl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            loader.classList.remove("loading");

            var wrapperClass = clicker.getAttribute("data-wrapper");
            var wrapper = clicker.closest("section").classList.contains('section-flexible') ?
              clicker.closest("section").querySelector('.' + wrapperClass) :
              document.querySelector('.' + wrapperClass);

            wrapper.insertAdjacentHTML('beforeend', xhr.responseText);

            page += 1;
            clicker.setAttribute("data-page", page);
            if (page > parseInt(clicker.getAttribute("data-max"))) {
              clicker.style.display = 'none';
            }
          }
        };
        xhr.send('action=gblloadmore&post_type=' + clicker.getAttribute("data-type") + '&pa=' + clicker.getAttribute("data-page") + '&nb=' + clicker.getAttribute("data-nb") + '&taxo=' + clicker.getAttribute("data-tax"));

        loader.classList.add("loading");
      }
      event.preventDefault();
    }
  });
});


/* Parallax mouse
========================================================================== */
// document.addEventListener("DOMContentLoaded", () => {
//    const parallaxMouse = document.querySelectorAll('.parallax-mouse');

//    if (parallaxMouse.length > 0) {
//       let ticking = false;

//       function handleMouseMove({ clientX: x, clientY: y }) {
//          const centerX = window.innerWidth / 2;
//          const centerY = window.innerHeight / 2;

//          const offsetX = (x - centerX) / centerX;
//          const offsetY = (y - centerY) / centerY;

//          document.documentElement.style.setProperty('--parallax-x-left', offsetX);
//          document.documentElement.style.setProperty('--parallax-y', offsetY);
//          // Set the horizontal offset for the right parallax element based on mouse movement
//          document.documentElement.style.setProperty('--parallax-x-right', offsetX);
//          ticking = false;
//       }

//       function onMouseMove(event) {
//          if (!ticking) {
//             requestAnimationFrame(() => handleMouseMove(event));
//             ticking = true;
//          }
//       }

//       function updateMouseMoveListener() {
//          if (window.innerWidth > 992) {
//             document.addEventListener('mousemove', onMouseMove);
//          } else {
//             document.removeEventListener('mousemove', onMouseMove);
//          }
//       }

//       updateMouseMoveListener();
//       window.addEventListener('resize', updateMouseMoveListener);
//    }
// });

/* Parallax scroll
========================================================================== */
// document.addEventListener("DOMContentLoaded", () => {
//    const parallaxVertical = document.querySelectorAll('.parallax-vertical .item');
//    const parallaxHorizontal = document.querySelectorAll('.parallax-horizontal .item');
//    const parallaxGeneral = document.querySelectorAll('.parallax-all .item');

//    if ((parallaxVertical.length || parallaxHorizontal.length || parallaxGeneral.length) && window.innerWidth > 992) {
//       let ticking = false;

//       const translateValuesX = [15, -10];
//       const translateValuesY = [15, -15];
//       const translateValuesAllX = [15, -10];
//       const translateValuesAllY = [15, -15];

//       function handleScrollParallax() {
//          const scrollTop = window.scrollY;
//          const divHeight = window.innerHeight;

//          parallaxVertical.forEach((item, index) => {
//             let itemPos = (scrollTop + divHeight - (item.getBoundingClientRect().top + scrollTop)) / divHeight;
//             itemPos = Math.min(1, Math.max(0, itemPos));
//             item.dataset.scrollpos = itemPos;

//             const translateValueY = (translateValuesY[index] || 0) * itemPos;
//             item.style.transform = `translateY(${translateValueY}%)`;
//          });

//          parallaxHorizontal.forEach((item, index) => {
//             let itemPos = (scrollTop + divHeight - (item.getBoundingClientRect().top + scrollTop)) / divHeight;
//             itemPos = Math.min(1, Math.max(0, itemPos));
//             item.dataset.scrollpos = itemPos;

//             const translateValueX = (translateValuesX[index] || 0) * itemPos;
//             item.style.transform = `translateX(${translateValueX}%)`;
//          });

//          parallaxGeneral.forEach((item, index) => {
//             let itemPos = (scrollTop + divHeight - (item.getBoundingClientRect().top + scrollTop)) / divHeight;
//             itemPos = Math.min(1, Math.max(0, itemPos));
//             item.dataset.scrollpos = itemPos;

//             const translateValueX = (translateValuesAllX[index % translateValuesAllX.length] || 0) * itemPos;
//             const translateValueY = (translateValuesAllY[index % translateValuesAllY.length] || 0) * itemPos;

//             item.style.transform = `translateX(${translateValueX}%) translateY(${translateValueY}%)`;
//          });

//          ticking = false;
//       }

//       window.addEventListener('scroll', () => {
//          if (!ticking) {
//             requestAnimationFrame(handleScrollParallax);
//             ticking = true;
//          }
//       });

//       handleScrollParallax();
//    }
// });




document.addEventListener('DOMContentLoaded', () => {
    const popups = document.querySelectorAll('.modal.popup');
    var popups_scroll = [];

    if(popups.length > 0){
        popups.forEach(popup => {

            const id = popup.id;
            const show_behavior = popup.dataset.show_behavior;
            const show_behavior_days = popup.dataset.show_behavior_days ? popup.dataset.show_behavior_days : 7;
            const scroll_enabled = popup.dataset.scroll_enabled == '1';
            var show = false;
            if(show_behavior == 'show_once'){
                //if show_behavior is set to show_once => check cookie before showing
                //if cookie exists, do not show
                const cookie = getCookie(id);
                if(cookie == 'shown'){
                    show = false;
                }
                else{
                    //if show_behavior is set to show_once => save to cookie on close
                    popup.addEventListener('close', function(){
                        setCookie(id, 'shown', show_behavior_days);
                    });

                    show = true;
                }
            }
            else if(show_behavior == 'show_session'){
                //if show_behavior is set to show_session => check session before showing
                //if session exists, do not show
                const session = sessionStorage.getItem(id);
                if(session == 'shown'){
                    show = false;
                }
                else{
                    //if show_behavior is set to show_session => save to session on close
                    popup.addEventListener('close', function(){
                        sessionStorage.setItem(id, 'shown');
                    });

                    show = true;
                }
            }
            else{
                show = true;
            }

            if (show && scroll_enabled){
                //if scroll_enabled is set to true => add popup to popups_scroll array
                show = false;
                popups_scroll.push(id);
            }

            if(show){
                openModal(id);
            }
            
        });

        window.addEventListener('scroll', function () {
            updateScrollPopups();
        });
            

        function updateScrollPopups(){
            if (popups_scroll.length) {
                popups_scroll.forEach(popup_id => {
                    const popup = document.getElementById(popup_id);
                    if (popup) {
                        const scroll_value = popup.dataset.scroll_value;
                        const scroll_units = popup.dataset.scroll_units;
                        const max_scroll = Math.max(0, document.body.clientHeight - window.innerHeight);
                        var show = false;
                        if (scroll_units == 'pct') {
                            const window_scroll_percentage = window.scrollY / (document.body.clientHeight - window.innerHeight) * 100;
                            if (window_scroll_percentage > scroll_value || max_scroll == 0) {
                                show = true;
                            }
                        }
                        else {
                            if (window.scrollY > scroll_value || (max_scroll < scroll_value && window.scrollY == max_scroll)) {
                                show = true;
                            }
                        }

                        if (show) {
                            const index = popups_scroll.indexOf(popup_id);
                            if (index > -1) {
                                popups_scroll.splice(index, 1);
                            }
                            openModal(popup_id);
                        }
                    }
                });
            }
        }

        updateScrollPopups();//launch on loaded in case of impossible scroll values
    }
});

/* ScrollMagic
========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var controller = new ScrollMagic.Controller();
  const animates = document.querySelectorAll('.animate');
  if(animates.length){
    animates.forEach(animate => {
      var scene = new ScrollMagic.Scene({
        triggerElement: animate,
        triggerHook: 0.7,
        // duration: $(this).height()
      })
      .setClassToggle(animate, 'is-animate')
      .reverse(false)
      // .addIndicators()
      .addTo(controller);
    });
  }
});

/* Share
========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.share').forEach(function (element) {
        element.addEventListener('click', function () {
            this.classList.toggle('open');
        });
    });
});


document.addEventListener('DOMContentLoaded', function () {
  /**
   * Config defaut SplideJS
   * Docs: https://splidejs.com/guides/options/
   */
  Splide.defaults = {
    type         : 'loop',
    autoplay     : false,
    pauseOnHover : false,
    speed        : 300,
    drag         : true,
    pagination   : true,
    perPage      : 1,
    gap          : 20,   // gap between slides
    mediaQuery   : 'min' // or 'max'. Used to define the rule to apply the breakpoints options.
  }

  // -------------------------------------------------------------
  // Clients sliders
  // -------------------------------------------------------------

  // Gammes slider
  const gammesSlider = document.querySelector('.gammes-slider');
  if (gammesSlider) {
    new Splide(gammesSlider, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      padding: { left: 50, right: 100 }, // Asymétrique : plus d'espace à droite
      trimSpace: false,
      pagination: false,
      arrows: false,
      updateOnMove: true,
      cloneStatus: true,
    }).mount();
  }
});

document.addEventListener('DOMContentLoaded', function () {

  // -------------------------------------------------------------
  // SLIDERS BEFORE INIT
  // -------------------------------------------------------------
  const splides = document.querySelectorAll('.splide');
  splides.forEach(splide => {
    splide.dataset.slides = splide.querySelectorAll('.item').length;
  })

  // -------------------------------------------------------------
  // Text & Picture
  // -------------------------------------------------------------
  const sliderTexts = document.querySelectorAll('.section-slidertxt .splide');
  if (sliderTexts) {
    sliderTexts.forEach(sliderText => {
      const slider = new Splide(sliderText, {
        breakpoints: {
          992: {
            autoplay: true,
            pauseOnHover: true,
            gap: 30,
          }
        }
      }).mount();

      if (slider.length === 1) {
        slider.destroy();
      }
    });
  }

  // -------------------------------------------------------------
  // Multiple columns
  // -------------------------------------------------------------
  const sliderColumns = document.querySelectorAll('.section-multiplecol .splide');
  if (sliderColumns) {
    sliderColumns.forEach(sliderColumn => {

      const slider = new Splide(sliderColumn, {
        breakpoints: {
          768: {
            perPage: 2,
          },
          992: {
            perPage: 3,
            gap: 30,
            autoplay: true,
            pauseOnHover: true,
          },
          1200: {
            perPage: 4,
            gap: 30,
            autoplay: true,
            pauseOnHover: true,
          }
        }
      }).mount();

      // on resize, get perPage value from --number-item-list css var
      handlePerPage(sliderColumn, slider);
      window.addEventListener('resize', () => {
        handlePerPage(sliderColumn, slider);
      });

    });
  }

  // -------------------------------------------------------------
  // Static lists
  // -------------------------------------------------------------
  const sliderStatic = document.querySelectorAll('.section-listestatique .splide');
  if (sliderStatic) {
    initListSliders(sliderStatic);
  }

  // -------------------------------------------------------------
  // Dynamic lists
  // -------------------------------------------------------------
  const sliderDynamic = document.querySelectorAll('.section-listedynamique .splide');
  if (sliderDynamic) {
    initListSliders(sliderDynamic);
  }

  // -------------------------------------------------------------
  // Gallery
  // -------------------------------------------------------------
  const sliderGallery = document.querySelectorAll('.section-gallery .splide:not(.thumbnail-dots)'); //Select only main sliders, not the thumbnail ones
  if (sliderGallery) {
    sliderGallery.forEach(slider => {
      const isVideo = slider.closest('.section-gallery').classList.contains('layout-content-videos');

      const mainOptions = {
        breakpoints: {
          992: {
            autoplay: true,
            pauseOnHover: true,
          }
        }
      };

      //IF video and loop, video init issues between clones/items => force slide
      if(isVideo){
        mainOptions.type = 'slide';
      }

      const thumbnailsOptions = {
        type: 'slide',
        fixedWidth: 50,
        fixedHeight: 50,
        gap: 10,
        rewind: true,
        pagination: false,
        isNavigation: true,
        breakpoints: {
          768: {
            fixedWidth: 100,
            fixedHeight: 100,
          },
        },
      };

      let main = null;
      if (slider.classList.contains('slider-gallery-thumb')) {
        const parentSection = slider.closest('.section-gallery');
        const thumbSliderEl = parentSection.querySelector('.thumbnail-dots');

        if (!thumbSliderEl) {
          return;
        }

        mainOptions.type = 'fade';
        mainOptions.autoplay = false;
        //mainOptions.arrows = false;
        //mainOptions.pagination = false;
        mainOptions.rewind = true;

        main = new Splide(slider, mainOptions);
        const thumbnails = new Splide(thumbSliderEl, thumbnailsOptions);

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();
      } else {
        main = new Splide(slider, mainOptions);
        main.mount();
      }

      handlePerPage(slider, main);

      // Stop all video on transition
      if (isVideo && main) {
        main.on('moved', function () {
          const videos = slider.querySelectorAll('iframe');
          videos.forEach(video => {
            window.stopVideo(video);
          });
        });
      }
    });
  }
});

function initListSliders(elements) {
  elements.forEach(element => {
    const options = {
      breakpoints: {
        992: {
          perPage: 1,
          gap: 30,
          autoplay: true,
          pauseOnHover: true,
        },
        1600: {
          perPage: 2,
          gap: 30,
          autoplay: true,
          pauseOnHover: true,
        }
      }
    };

    const classNames = ['default', 'text-bottom'];
    if (classNames.some(className => element.classList.contains(className))) {
      options.breakpoints = {
        768: {
          perPage: 2,
        },
        992: {
          perPage: 3,
          gap: 30,
          autoplay: true,
          pauseOnHover: true,
        },
        1200: {
          perPage: 4,
          gap: 30,
          autoplay: true,
          pauseOnHover: true,
        }
      };
    }
    const slider = new Splide(element, options).mount();

    if (slider.length === 1) {
      slider.destroy();
    } else {
      // on resize, get perPage value from --number-item-list css var
      handlePerPage(element, slider);
      window.addEventListener('resize', () => {
        handlePerPage(element, slider);
      });
    }
  });
}

function handlePerPage(element, slider) {
  const parentEl = element.closest('.section-flexible');
  if (!parentEl) {
    return;
  }

  var perPage = getComputedStyle(parentEl).getPropertyValue('--number-item-list');
  if (perPage) {
    if(perPage >= element.dataset.slides){
      
      slider.destroy(true);
      element.dataset.destroy = 'true';
      element.classList.add('slider-destroyed');
      parentEl.classList.add('slider-destroyed');

      perPage = parseInt(element.dataset.slides);

    }
    else{
      if(element.dataset.destroy == 'true'){
        slider.mount();
        element.dataset.destroy = 'false';
        element.classList.remove('slider-destroyed');
        parentEl.classList.remove('slider-destroyed');
      }
    }
    
    slider.options.perPage = parseInt(perPage);
    slider.refresh();

  }
}

/* Sticky Menu
========================================================================== */

document.addEventListener("DOMContentLoaded", function () {

	// init sticky menu
	var lastScrollPosition = 0;
	var currentScrollPosition = window.scrollY;
	document.body.classList.add("has-sticky-menu");
	
	if (currentScrollPosition > 20) {
		document.body.classList.add("sticky-menu");
	} else {
		document.body.classList.remove("sticky-menu");
	}
	lastScrollPosition = currentScrollPosition;

	// update menu at scroll (vanilla)
	window.onscroll = function () {
		currentScrollPosition = window.scrollY;
		if (currentScrollPosition > 20) {
			document.body.classList.add("sticky-menu");
		} else {
			document.body.classList.remove("sticky-menu");
		}
		if (currentScrollPosition > lastScrollPosition) {
			document.body.classList.remove("scroll-up");
			document.body.classList.add("scroll-down");
		} else {
			document.body.classList.remove("scroll-down");
			document.body.classList.add("scroll-up");
		}
		lastScrollPosition = currentScrollPosition;
	}

});



/* Tabs
========================================================================== */
document.addEventListener("DOMContentLoaded", function () {
  const tabWrappers = document.querySelectorAll(".tabs-wrapper");

  if (tabWrappers.length > 0) {
    tabWrappers.forEach((wrapper) => {
      wrapper.querySelectorAll(".tab-menu-item a").forEach((anchor) => {
        anchor.addEventListener("click", (event) => {
          event.preventDefault();
          openTab(anchor.getAttribute("href"), wrapper);
        });
      });
    });

    function openTab(tabId, wrapper) {
      const link = wrapper.querySelector('a[href="' + tabId + '"]');
      wrapper.querySelectorAll(".tab-menu-item").forEach((item) => {
        item.classList.remove("active", "in");
      });
      link.parentElement.classList.add("active", "in");

      wrapper.querySelectorAll(".tabs-item").forEach((item) => {
        item.classList.remove("active", "in");
      });
      wrapper.querySelector(tabId).classList.add("active", "in");
    }

    const hash = location.hash;
    if (hash) {
      tabWrappers.forEach((wrapper) => {
        if (wrapper.querySelector(hash) && wrapper.querySelector(hash).classList.contains("tabs-item")) {
          openTab(hash, wrapper);
        }
      });
    }
  }
});


/* Toggle
========================================================================== */

window.onload = function () {
	initToggles();
}

function initToggles() {
	const faq_toggles_content = document.querySelectorAll(".toggle-wrapper .toggle-content");
	if (faq_toggles_content) {
		faq_toggles_content.forEach(function (item) {
			var origHeight = item.getBoundingClientRect().height;
			item.setAttribute('origHeight', origHeight);
			item.style.height = '0px';
		})
	}
}

const faq_toggles = document.querySelectorAll('.toggle-item input[name=toggle]');
if (faq_toggles) {
	faq_toggles.forEach(function (item) {

		// item.addEventListener('focus', function (event) {

		// 	item.classList.add('focuson');

		// 	toggleItem(item);

		// 	setTimeout(function(){
		// 		item.classList.remove('focuson');
		// 	}, 100);
		// })

		item.addEventListener('change', function (event) {
			if(item.classList.contains('focuson')){
				//if focused ignore change event, otherwise will open/close
				return;
			}

			toggleItem(item);
		})

		function toggleItem(item){
			let parent = item.closest('.toggle-wrapper');
			let faqs_cb = parent.querySelectorAll('input[name=toggle]');
			let toggle_item = item.closest('.toggle-item');
			let toggle_content = toggle_item.querySelector('.toggle-content');

			if (faqs_cb) {
				faqs_cb.forEach(function (cb) {
					if (item != cb) {
						cb.checked = false;
					}
				})
			}

			if (toggle_item.classList.contains('active')) {
				toggle_item.classList.remove('active');
				toggle_content.style.height = '0px';
			}
			else {
				let toggle_item_active = parent.querySelector('.toggle-item.active');
				if (toggle_item_active) {
					toggle_item_active.querySelector('.toggle-content').style.height = '0px';
					toggle_item_active.classList.remove('active');
				}

				let toggle_content_h = toggle_content.getAttribute('origHeight') + 'px';
				toggle_content.style.height = toggle_content_h;
				toggle_item.classList.add('active');
			}
		}

	})
}


/* Video
========================================================================== */

var videoIds = new Array();
var hpVideo = null;
var byUser = false;
var currentPlayer = null;


window.addEventListener("load", function () {  
  //initVideoPlayBtns
  initVideoPlayBtns();
});



function onYouTubeIframeAPIReady() {
  for (property in yt_videos) {
    var AutoPlay = 0;
    const video = document.getElementById('video_' + property);
    if(video && video.classList.contains('autoPlaycustom')) {
      AutoPlay = 1;
    }

    videoIds[property] = 'video_' + property;
  }
}

function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.PLAYING) {
    var el = event.target.getIframe();
    var id = el.getAttribute("id");
    splittedId = id.split('_');
    ytId = splittedId[1];
    stopAllButThisVideo(ytId);

  } else {
    if (event.data == YT.PlayerState.ENDED) {
      var el = event.target.getIframe();
      el.nextElementSibling.style.display = 'block';
    }
  }
}

function initVideoPlayBtns() {
  const btns = document.querySelectorAll('.videoPlay:not(.init)');
  btns.forEach(function (btn) {
    btn.classList.add('init');
    btn.addEventListener('click', function () {
      var clicker = this;
      initVideo(clicker, false);
    });

    if(btn.classList.contains('autoplay')) {
      var clicker = btn;
      initVideo(clicker, true);
      clicker.style.display = 'none';
    }
  });
}



function initVideo(clicker, autoplay = false, autoplaymute = true) {
  if (clicker.dataset.video) {
    var provider = clicker.parentElement.dataset.provider;
    if (typeof provider != 'undefined' && provider == 'youtube') {
      //videoIds[$clicker.data("video")].playVideo();
      if (!autoplay) {
        stopAllButThisVideo(clicker.dataset.video);
      }
      var property = clicker.dataset.video;
      var video = new YT.Player("video_" + property, {
        height: "100%",
        width: "100%",
        playerVars: {
          autoplay: 1,
          loop: 0,
          mute: autoplay && autoplaymute, // required for autoplay
          controls: 1,
          iv_load_policy: 3,
          rel: 0,
          showinfo: 0,
          autohide: 1,
          modestbranding: 1,
          //vq: 'hd1080'
        },
        videoId: yt_videos[property],
          events: {
            'onStateChange': onPlayerStateChange
          }
      });
      videoIds[property] = video;
      if (currentPlayer == null) {
        currentPlayer = video;
      }

      setTimeout(function () {
        clicker.style.display = 'none';
      }, 100)
      
    }
    else if (typeof provider != 'undefined' && provider == 'vimeo') {
      if (typeof clicker.dataset.wrapper != "undefined") {
        var vimeoID = clicker.dataset.video;
        if (!autoplay) {
          stopAllButThisVideo(vimeoID);
        }
        var wrapperID = clicker.dataset.wrapper;

        var settings = {
          id: vimeoID,
          controls: true,
          autoplay: true,
          muted: autoplay, // required for autoplay
        };
        var Player = new Vimeo.Player(
          clicker.parentElement,
          settings
        );
        Player.on("loaded", function (data) {
          this.play();
          clicker.style.display = 'none';
        });
        videoIds[wrapperID] = Player;
      }
    }
  }
}

function stopAllButThisVideo(videoId) {
  const videos = document.querySelectorAll('div[data-provider] iframe');
  videos.forEach(function (video) {
    if (video.getAttribute('id') != 'video_' + videoId) {
      window.stopVideo(video);
    }
  });
}


window.stopVideo = function (video) {
  var id = video.getAttribute("id");
  if(!id) { //vimeo
    id = video.parentElement.querySelector('a').dataset.wrapper;
  }
  splittedId = id.split('_');
  ytId = splittedId[1];
  if (typeof videoIds[ytId] != 'undefined') {
    videoIds[ytId].pauseVideo();
  }
  else if (typeof videoIds[id] != 'undefined') {
    videoIds[id].pause();
  }
}

window.playVideo = function (video) {
  var id = video.getAttribute("id");
  if (!id) { //vimeo
    id = video.parentElement.querySelector('a').dataset.wrapper;
  }
  splittedId = id.split('_');
  ytId = splittedId[1];
  videoIds[ytId].play();
  if (document.body.classList.contains("home")) {
    document.querySelector(".hp-video .bg-img.videoPlay").style.display = 'none';
  }
}

window.muteVideo = function (video, mute = true) {
  var id = video.getAttribute("id");
  splittedId = id.split('_');
  ytId = splittedId[1];
  videoIds[ytId].setMuted(mute);
}
